import "./style.css";
import { jsxs as W, jsx as l, Fragment as oA } from "react/jsx-runtime";
import * as V from "react";
import { forwardRef as iA, createContext as vA, useContext as hA, isValidElement as UA, Fragment as jA, useRef as $, useState as z, useEffect as J, useCallback as H, createElement as $A, useMemo as dA } from "react";
import Me from "react-dom/server";
const Z = {
  AUDIO_BUTTON: "audio-button",
  NOTIFICATION_BUTTON: "notification-button",
  CLOSE_CHAT_BUTTON: "close-chat-button",
  SEND_MESSAGE_BUTTON: "send-button",
  VOICE_MESSAGE_BUTTON: "voice-button",
  FILE_ATTACHMENT_BUTTON: "file-attachment-button",
  EMOJI_PICKER_BUTTON: "emoji-button"
}, ke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2042%2042'%3e%3cpath%20style='fill:none;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke:%23b00000;stroke-opacity:1;stroke-miterlimit:4'%20d='M17%209a8%208%200%200%201-8%208%208%208%200%200%201-8-8%208%208%200%200%201%208-8%208%208%200%200%201%208%208Zm0%200'%20transform='rotate(.086)%20scale(1.77778)'/%3e%3cpath%20style='fill:none;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke:%23b00000;stroke-opacity:1;stroke-miterlimit:10'%20d='M14.66%2014.66%203.34%203.34'%20transform='rotate(.086)%20scale(1.77778)'/%3e%3c/svg%3e", Ae = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20viewBox='0%200%201000%201000'%3e%3crect%20width='100%25'%20height='100%25'%20fill='%23fff'/%3e%3cg%3e%3crect%20width='45'%20height='30'%20x='-22.5'%20y='-15'%20rx='1.5'%20ry='1.5'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2337547a;fill-rule:nonzero;opacity:1'%20transform='rotate(90%20-99%20362)%20scale(3.4003)'/%3e%3cpath%20d='M0%2075q14%200%2014%2017%200%2016-14%2016Z'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2398b0ca;fill-rule:nonzero;opacity:1'%20transform='rotate(180%20106%20386)%20scale(3.4003)'/%3e%3crect%20width='25'%20height='4'%20x='-12.5'%20y='-2'%20rx='.2'%20ry='.2'%20style='stroke:%2346648c;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2346648c;fill-rule:nonzero;opacity:1'%20transform='rotate(90%20-46%20282)%20scale(3.4003)'/%3e%3cpath%20d='M19%2065h4l5%204v1H14v-1Z'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2346648c;fill-rule:nonzero;opacity:1'%20transform='translate(165%20150)%20scale(3.4003)'/%3e%3crect%20width='25'%20height='2'%20x='-12.5'%20y='-1'%20rx='.1'%20ry='.1'%20style='stroke:%2398b0ca;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2398b0ca;fill-rule:nonzero;opacity:1'%20transform='rotate(90%20-3%20240)%20scale(3.4003)'/%3e%3ccircle%20r='7.5'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%23a478fc;fill-rule:nonzero;opacity:1'%20transform='translate(236%20175)%20scale(3.4003)'/%3e%3crect%20width='45'%20height='30'%20x='-22.5'%20y='-15'%20rx='1.5'%20ry='1.5'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2337547a;fill-rule:nonzero;opacity:1'%20transform='rotate(90%20139%20600)%20scale(3.4003)'/%3e%3cpath%20d='M184%2075q14%200%2014%2017%200%2016-14%2016Z'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2398b0ca;fill-rule:nonzero;opacity:1'%20transform='translate(165%20150)%20scale(3.4003)'/%3e%3crect%20width='25'%20height='4'%20x='-12.5'%20y='-2'%20rx='.2'%20ry='.2'%20style='stroke:%2346648c;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2346648c;fill-rule:nonzero;opacity:1'%20transform='rotate(90%20219%20548)%20scale(3.4003)'/%3e%3cpath%20d='M175%2065h4l5%204v1h-14v-1Z'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2346648c;fill-rule:nonzero;opacity:1'%20transform='translate(165%20150)%20scale(3.4003)'/%3e%3crect%20width='25'%20height='2'%20x='-12.5'%20y='-1'%20rx='.1'%20ry='.1'%20style='stroke:%2398b0ca;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2398b0ca;fill-rule:nonzero;opacity:1'%20transform='rotate(90%20262%20505)%20scale(3.4003)'/%3e%3ccircle%20r='7.5'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%23a478fc;fill-rule:nonzero;opacity:1'%20transform='translate(767%20175)%20scale(3.4003)'/%3e%3crect%20width='116.7'%20height='70'%20x='-58.4'%20y='-35'%20rx='31.5'%20ry='31.5'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2371c9fc;fill-rule:nonzero;opacity:1'%20transform='translate(502%20877)%20scale(3.4003)'/%3e%3crect%20width='60'%20height='20'%20x='-30'%20y='-10'%20rx='3'%20ry='3'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2337547a;fill-rule:nonzero;opacity:1'%20transform='translate(502%20728)%20scale(3.4003)'/%3e%3ccircle%20r='75'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%2371c9fc;fill-rule:nonzero;opacity:1'%20transform='translate(502%20473)%20scale(3.4003)'/%3e%3crect%20width='129.4'%20height='82.3'%20x='-64.7'%20y='-41.1'%20rx='37'%20ry='37'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%23fff;fill-rule:nonzero;opacity:1'%20transform='translate(502%20464)%20scale(3.4003)'/%3e%3crect%20width='108'%20height='68.6'%20x='-54'%20y='-34.3'%20rx='30.9'%20ry='30.9'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%23162334;fill-rule:nonzero;opacity:1'%20transform='translate(502%20464)%20scale(3.4003)'/%3e%3ccircle%20r='19.4'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%23a478fc;fill-rule:nonzero;opacity:1'%20transform='translate(415%20464)%20scale(3.4003)'/%3e%3ccircle%20r='19.4'%20style='stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%23a478fc;fill-rule:nonzero;opacity:1'%20transform='translate(591%20464)%20scale(3.4003)'/%3e%3crect%20width='96'%20height='53.2'%20x='-48'%20y='-26.6'%20rx='23.9'%20ry='23.9'%20style='stroke:%23162334;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;is-custom-font:none;font-file-url:none;fill:%23162334;fill-rule:nonzero;opacity:1'%20transform='translate(503%20875)%20scale(3.4003)'/%3e%3cpath%20stroke-linecap='round'%20d='m68%20215%207-15M81%20222l-7-22M81%20222l7-14M101%20208H87M114%20219l-7-24M113%20219l13-22M131%20214l-5-17M148%20214h-18M69%20214H51M100%20209l7-15'%20style='stroke:%23a478fc;stroke-width:3;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:10;is-custom-font:none;font-file-url:none;fill:none;fill-rule:nonzero;opacity:1'%20transform='translate(165%20150)%20scale(3.4003)'/%3e%3c/g%3e%3c/svg%3e", He = "data:image/svg+xml,%3csvg%20width='140'%20height='140'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cy='60.044'%20cx='70'%20fill='%235c5c5c'%20r='29'/%3e%3cpath%20d='m16.36%20156.186-.01-30.5c-.005-16.844%2024.168-30.507%2053.991-30.516%2029.823-.009%2054.004%2013.64%2054.01%2030.484l.008%2030.5-108%20.032z'%20fill='%235c5c5c'/%3e%3c/svg%3e", xe = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 0 637 637", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "m478 113-13 2-4 1h4l14-2c10-2 35-2 42-1l6 3 3 1c3 0-4-3-8-5-7-1-34-1-44 1m56 6 8 6c7 5 20 17 20 19s7 12 8 12l-3-6-4-6c0-3-15-17-25-24-5-3-8-4-4-1m-198 16-9 1a512 512 0 0 1 9-1m-180 30a412 412 0 0 0-23 4 167 167 0 0 0-32 8 439 439 0 0 1 46-9 304 304 0 0 1 11-2l6-1h-8m369 8 4 3-7-6c-1 0 0 2 3 3m-439 9c-7 3-18 13-18 15l6-5c5-5 9-8 14-10l6-4-8 4m442 12-10 11-7 6 7-6c7-5 14-14 13-16l-3 5M65 205l-1 11c0 9 0 10 4 17 5 10 7 12 22 11 10 0 15 0 38-5l5-1-6 1-16 2-21 2c-13 1-16-1-21-10-3-5-4-6-4-15l1-12c1-4 1-5-1-1m335 1c3 0 3 1 3 3l-2 6c-2 5-35 39-76 80-53 51-120 117-138 137-21 24-22 25-22 27 0 3 6 9 9 9 4 0 14-8 38-27a5073 5073 0 0 1 15-16 1421 1421 0 0 0-17 15l-31 25-6 2-4-3c-3-3-3-4-2-6 3-8 79-85 160-163 57-57 79-80 79-86 0-2-3-4-7-4-2 0-2 0 1 1m165 18c-9 17-25 32-57 53l-10 8 16-11 12-8c15-10 27-22 39-39 5-7 6-8 4-8l-4 5m-221 2a199 199 0 0 0-19 10 183 183 0 0 1 27-12c0-1-1-1-8 2m-34 16c-3 3-2 3 2 0l1-2-3 2m151 3-1 2 2-2c3-3 2-3-1 0m-16 12-11 10a281 281 0 0 0 11-10m-24 18-7 5-7 5-42 31c-10 7-24 19-22 19l7-6 16-12a343 343 0 0 0 35-25 573 573 0 0 0 20-17m-187 0-2 2 4-2 3-2-5 2m-14 6-3 2 4-1 4-3-5 2m-7 3-8 4-18 8 18-7 7-3 3-1c1-2 0-2-2-1m254 24a2672 2672 0 0 1-71 54 601 601 0 0 0 39-29 1352 1352 0 0 1 32-25m-291-8-2 2 4-2 3-2-5 2m-13 5-2 2h3c5-3 4-4-1-2m-19 9-7 3-13 6c-10 5-13 7-14 10-3 4-2 5 1 0 2-3 5-5 14-9l13-6 12-6-6 2m178 36c-17 12-21 16-21 17a390 390 0 0 1 20-17m-206 34 1 4 1 3 1 5 2 8 1 5v-6l-1-8-2-5-1-4-1-2c-1-2-1-2-1 0m222 23-9 7a683 683 0 0 0-56 44 261 261 0 0 0-26 20 1345 1345 0 0 0-46 34c-6 3-7 3-19 3-11 0-12 0-18-3-8-4-10-8-17-20l-5-10 4 10c5 10 12 18 19 22 4 2 6 2 17 2 13 0 14 0 21-3l26-19 42-33a2183 2183 0 0 0 43-34 643 643 0 0 1 24-20", fill: "#fff", fillRule: "evenodd" }), /* @__PURE__ */ V.createElement("path", { d: "M478 114a620 620 0 0 1-39 6l-21 3a5481 5481 0 0 0-19 3 870 870 0 0 1-54 8l-1 1-6 1-12 2-13 2a992 992 0 0 0-76 12 400 400 0 0 1-45 8l-6 1-5 1h-3l-3 1-2 1-26 4-13 2-17 3c-23 5-33 9-43 19-7 8-9 13-9 27 0 8 1 9 4 14 5 9 8 11 21 10l21-2a1133 1133 0 0 1 23-4 659 659 0 0 0 74-14l3-1h3l3-1h3l2-1 2-1h3l2-1h2l24-5 38-7a2100 2100 0 0 1 93-18l3-1 10-1a2082 2082 0 0 1 120-17l2 1c2 0 8 5 8 7l1 2 1 6c0 4 0 6-3 10-2 4-16 16-18 16l-7 5-10 8a1070 1070 0 0 0-11 7 113 113 0 0 1-20 14l-2 2-3 2-2 2h-1a154 154 0 0 1-28 21l-5 4-5 4a573 573 0 0 1-50 37 175 175 0 0 0-24 18l-1 2-2 1-2 1-2 1-1 1-12 10a396 396 0 0 0-32 25l-8 6-6 5-9 7a326 326 0 0 1-25 20l-13 12a5073 5073 0 0 0-17 15c-24 20-34 27-39 27-2 0-8-6-8-9 0-2 1-3 22-27 18-20 85-86 138-137 41-41 74-75 76-80l2-6c0-2 0-3-2-3l-7 1a233 233 0 0 1-26 9l-1 1-1 1h-1l-1 1h-2l-3 2-1 1h-2l-3 2h-1l-5 2-22 10-9 4-4 2-5 2-10 4-2 1-2 1-2 1-13 6a334 334 0 0 1-38 17 75 75 0 0 0-14 6l-5 2-4 1-2 1-3 2-7 3-16 6a247 247 0 0 0-32 14l-1 1h-2l-1 1h-2l-1 1-12 6a103 103 0 0 0-27 15l-2 5-1 1v11l1 5 1 5 1 4c0 3 0 4 2 4v3l1 3 1 2 2 10 1 4 1 5 2 10 2 8 1 4 1 4c3 3 9 25 11 38l1 7v2l1 4v1l1 1v2l1 2 1 3v1l5 10c7 13 9 16 17 20 6 3 7 3 18 3 12 0 13 0 19-3 8-4 11-6 26-18a1345 1345 0 0 1 85-67 683 683 0 0 1 50-39l12-9a513 513 0 0 1 44-33 201 201 0 0 0 22-17 2270 2270 0 0 0 73-54 158 158 0 0 0 58-59c2 0 3-9 4-27l-1-19-1-4-1-6-1-3-4-6-4-6c0-2-6-8-13-14a77 77 0 0 0-28-18c-6-1-34-1-43 1" })), ee = iA(xe), Oe = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M765-321q0 117-84 196-83 80-200 80-118 0-200-80t-83-196v-392q0-85 61-144 61-58 146-58 86 0 147 58 61 59 61 144v374q0 54-39 92-39 37-93 37-55 0-93-37-38-38-38-92v-372h110v372q0 9 6 14t15 5q8 0 15-5t7-14v-374q0-39-29-66t-68-27q-40 0-69 27t-29 66v392q0 71 51 119t122 48q71 0 122-48t51-119v-426h111v426Z" })), te = iA(Oe), Le = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M125-165v-113h77v-273q0-93 55-167 56-75 146-100v-19q0-32 22-55 23-23 55-23t55 23q22 23 22 55v19q90 25 146 99 56 73 56 168v273h77v113H125ZM480-32q-38 0-66-27-27-27-27-66h186q0 39-27 66t-66 27Z" })), Ne = iA(Le), Re = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M137-190v-113h78v-253q0-41 11-79 11-39 35-71l-9 150h10L17-802l74-74L873-92l-74 74-175-172H137Zm609-149L319-769q20-15 41-25t44-16v-28q0-32 22-54t54-22q32 0 55 22t22 54v28q85 23 137 94t52 160v217ZM481-47q-38 0-65-27t-27-65h184q0 38-27 65t-65 27Z" })), Fe = iA(Re), Ue = (A, e) => /* @__PURE__ */ V.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ref: e, ...A }, /* @__PURE__ */ V.createElement("g", { strokeLinecap: "round", strokeWidth: 10 }, /* @__PURE__ */ V.createElement("path", { d: "m19 19 61 61M80 19 19 80" }))), je = iA(Ue), ze = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M94-136v-255l351-93-351-92v-253l816 346L94-136Z" })), Ge = iA(ze), Ye = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M480-372q-61 0-105-43-43-43-43-105v-240q0-61 43-105 43-43 105-43 61 0 105 43 43 44 43 105v240q0 62-43 105t-105 43ZM425-76v-122q-121-16-197-108t-76-214h109q0 91 64 154t155 63q91 0 155-63t64-154h109q0 122-77 214T534-198v122H425Z" })), Xe = iA(Ye), We = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "m763-343-80-79q8-20 13-44 5-23 5-54h109q0 49-11 95t-36 82ZM625-482 336-770v-2q3-56 45-96t101-40q62 0 105 43t43 105v249l-1 17q-1 7-4 12ZM427-76v-122q-120-16-196-108-77-92-77-214h109q0 91 64 154t155 63q43 0 80-14 37-15 67-41l78 79q-35 32-78 53t-93 28v122H427Zm362 27L41-796l75-75 748 748-75 74Z" })), Ke = iA(We), qe = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M625-511q29 0 50-21t20-50q0-29-20-50-21-20-50-20t-50 20-20 50q0 29 20 50 21 21 50 21Zm-290 0q29 0 50-21t20-49q0-30-20-50t-50-21q-29 0-50 20-20 21-20 50 0 30 20 50 21 21 50 21Zm145 268q75 0 137-43t85-115H258q24 72 85 115 62 43 137 43Zm0 198q-90 0-170-34-79-34-138-93T79-310q-34-80-34-170t34-170q34-79 93-138t138-93q80-34 170-34t170 34q79 34 138 93t93 138q34 80 34 170t-34 170q-34 79-93 138T650-79q-80 34-170 34Zm0-435Zm0 322q134 0 228-94t94-228q0-134-94-228t-228-94q-134 0-228 94t-94 228q0 134 94 228t228 94Z" })), oe = iA(qe), Je = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M553-64v-108q107-27 173-113 67-87 67-197 0-109-67-195T553-789v-108q152 26 249 144 97 117 97 271 0 155-97 273T553-64ZM61-335v-290h176l236-237v764L237-335H61Zm492 28v-346q51 23 82 70t31 103-31 103q-31 47-82 70Z" })), Ve = iA(Je), Ze = (A, e) => /* @__PURE__ */ V.createElement("svg", { viewBox: "0 -960 960 960", ref: e, ...A }, /* @__PURE__ */ V.createElement("path", { d: "M807-15 700-123q-33 21-71 37-38 15-80 22v-108q20-4 38-12l35-17-153-154v257L234-335H57v-290h144L10-818l74-75L882-90l-75 75Zm37-264-80-79q13-30 19-60 7-31 7-64 0-109-68-195-67-86-173-112v-108q152 26 249 144 98 117 98 271 0 55-14 107-13 51-38 96ZM661-462 549-575v-78q51 23 83 70 31 47 31 103l-1 9-1 9ZM469-655 366-759l103-103v207Z" })), _e = iA(Ze), $e = "data:audio/wav;base64,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", re = {
  general: {
    primaryColor: "#42b0c5",
    secondaryColor: "#491d8d",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    showHeader: !0,
    showFooter: !0,
    showInputRow: !0,
    actionDisabledIcon: ke,
    embedded: !1,
    flowStartTrigger: "ON_LOAD"
  },
  tooltip: {
    mode: "CLOSE",
    text: "Talk to me! 😊"
  },
  chatButton: {
    icon: ee
  },
  header: {
    title: /* @__PURE__ */ l("div", { style: { cursor: "pointer", margin: 0, fontSize: 20, fontWeight: "bold" }, onClick: () => window.open("https://github.com/tjtanjin/", "_blank", "noopener,noreferrer"), children: "Tan Jin" }),
    showAvatar: !0,
    avatar: Ae,
    buttons: [Z.NOTIFICATION_BUTTON, Z.AUDIO_BUTTON, Z.CLOSE_CHAT_BUTTON],
    closeChatIcon: je
  },
  notification: {
    disabled: !1,
    defaultToggledOn: !0,
    volume: 0.2,
    icon: Ne,
    iconDisabled: Fe,
    sound: $e,
    showCount: !0
  },
  audio: {
    disabled: !0,
    defaultToggledOn: !1,
    language: "en-US",
    voiceNames: ["Microsoft David - English (United States)", "Alex (English - United States)"],
    rate: 1,
    volume: 1,
    icon: Ve,
    iconDisabled: _e
  },
  chatHistory: {
    disabled: !1,
    maxEntries: 30,
    storageKey: "rcb-history",
    storageType: "LOCAL_STORAGE",
    viewChatHistoryButtonText: "Load Chat History ⟳",
    chatHistoryLineBreakText: "----- Previous Chat History -----",
    autoLoad: !1
  },
  chatInput: {
    disabled: !1,
    allowNewline: !1,
    enabledPlaceholderText: "Type your message...",
    disabledPlaceholderText: "",
    showCharacterCount: !1,
    characterLimit: -1,
    botDelay: 1e3,
    sendButtonIcon: Ge,
    blockSpam: !0,
    sendOptionOutput: !0,
    sendCheckboxOutput: !0,
    buttons: [Z.VOICE_MESSAGE_BUTTON, Z.SEND_MESSAGE_BUTTON]
  },
  chatWindow: {
    showScrollbar: !1,
    showTypingIndicator: !0,
    autoJumpToBottom: !1,
    showMessagePrompt: !0,
    messagePromptText: "New Messages ↓",
    messagePromptOffset: 30,
    defaultOpen: !1
  },
  sensitiveInput: {
    maskInTextArea: !0,
    maskInUserBubble: !0,
    asterisksCount: 10,
    hideInUserBubble: !1
  },
  userBubble: {
    animate: !0,
    showAvatar: !1,
    avatar: He,
    simulateStream: !1,
    streamSpeed: 30
  },
  botBubble: {
    animate: !0,
    showAvatar: !1,
    avatar: Ae,
    simulateStream: !1,
    streamSpeed: 30
  },
  voice: {
    disabled: !0,
    defaultToggledOn: !1,
    language: "en-US",
    timeoutPeriod: 1e4,
    autoSendDisabled: !1,
    autoSendPeriod: 1e3,
    sendAsAudio: !1,
    icon: Xe,
    iconDisabled: Ke
  },
  footer: {
    text: /* @__PURE__ */ W(
      "div",
      {
        style: { cursor: "pointer", display: "flex", flexDirection: "row", alignItems: "center", columnGap: 3 },
        onClick: () => window.open("https://react-chatbotify.com", "_blank", "noopener,noreferrer"),
        children: [
          /* @__PURE__ */ l("span", { children: "Powered By " }, 0),
          /* @__PURE__ */ l(
            "div",
            {
              style: {
                borderRadius: "50%",
                width: 14,
                height: 14,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "linear-gradient(to right, #42b0c5, #491d8d)"
              },
              children: /* @__PURE__ */ l(ee, { style: { width: "80%", height: "80%", fill: "#fff" } })
            },
            1
          ),
          /* @__PURE__ */ l("span", { style: { fontWeight: "bold" }, children: " React ChatBotify" }, 2)
        ]
      }
    ),
    buttons: [Z.FILE_ATTACHMENT_BUTTON, Z.EMOJI_PICKER_BUTTON]
  },
  fileAttachment: {
    disabled: !1,
    multiple: !0,
    accept: ".png",
    icon: te,
    iconDisabled: te,
    sendFileName: !0,
    showMediaDisplay: !1
  },
  emoji: {
    disabled: !1,
    icon: oe,
    iconDisabled: oe,
    list: ["😀", "😃", "😄", "😅", "😊", "😌", "😇", "🙃", "🤣", "😍", "🥰", "🥳", "🎉", "🎈", "🚀", "⭐️"]
  },
  toast: {
    maxCount: 3,
    forbidOnMax: !1,
    dismissOnClick: !0
  },
  event: {
    rcbPreInjectMessage: !1,
    rcbPostInjectMessage: !1,
    rcbStartSimulateStreamMessage: !1,
    rcbStopSimulateStreamMessage: !1,
    rcbStartStreamMessage: !1,
    rcbChunkStreamMessage: !1,
    rcbStopStreamMessage: !1,
    rcbRemoveMessage: !1,
    rcbLoadChatHistory: !1,
    rcbToggleChatWindow: !1,
    rcbStartSpeakAudio: !1,
    rcbToggleAudio: !1,
    rcbToggleNotifications: !1,
    rcbToggleVoice: !1,
    rcbChangePath: !1,
    rcbShowToast: !1,
    rcbDismissToast: !1,
    rcbUserSubmitText: !1,
    rcbUserUploadFile: !1,
    rcbTextAreaChangeValue: !1,
    rcbPreLoadChatBot: !1,
    rcbPostLoadChatBot: !1,
    rcbPreProcessBlock: !1,
    rcbPostProcessBlock: !1
  },
  ariaLabel: {
    chatButton: "open chat",
    audioButton: "toggle audio",
    closeChatButton: "close chat",
    emojiButton: "emoji picker",
    fileAttachmentButton: "upload file",
    notificationButton: "toggle notifications",
    sendButton: "send message",
    voiceButton: "toggle voice",
    inputTextArea: "input text area"
  },
  device: {
    desktopEnabled: !0,
    mobileEnabled: !0,
    applyMobileOptimizations: !0
  }
}, ae = vA({
  settings: {},
  setSyncedSettings: () => null,
  syncedSettingsRef: { current: {} }
}), N = () => hA(ae), At = ({
  children: A,
  settings: e = re,
  setSyncedSettings: o,
  syncedSettingsRef: t
}) => /* @__PURE__ */ l(ae.Provider, { value: { settings: e, setSyncedSettings: o, syncedSettingsRef: t }, children: A }), ce = {
  tooltipStyle: {},
  notificationBadgeStyle: {},
  chatWindowStyle: {},
  headerStyle: {},
  bodyStyle: {},
  chatInputContainerStyle: {},
  chatInputAreaStyle: {},
  chatInputAreaFocusedStyle: {},
  chatInputAreaDisabledStyle: {},
  userBubbleStyle: {},
  botBubbleStyle: {},
  botOptionStyle: {},
  botOptionHoveredStyle: {},
  botCheckboxRowStyle: {},
  botCheckboxNextStyle: {},
  botCheckMarkStyle: {},
  botCheckMarkSelectedStyle: {},
  characterLimitStyle: {},
  characterLimitReachedStyle: {},
  chatHistoryLineBreakStyle: {},
  chatMessagePromptStyle: {},
  chatMessagePromptHoveredStyle: {},
  footerStyle: {},
  loadingSpinnerStyle: {},
  mediaDisplayContainerStyle: {},
  chatButtonStyle: {},
  chatButtonHoveredStyle: {},
  chatHistoryButtonStyle: {},
  chatHistoryButtonHoveredStyle: {},
  sendButtonStyle: {},
  sendButtonHoveredStyle: {},
  sendButtonDisabledStyle: {},
  audioButtonStyle: {},
  audioButtonDisabledStyle: {},
  closeChatButtonStyle: {},
  emojiButtonStyle: {},
  emojiButtonDisabledStyle: {},
  fileAttachmentButtonStyle: {},
  fileAttachmentButtonDisabledStyle: {},
  notificationButtonStyle: {},
  notificationButtonDisabledStyle: {},
  voiceButtonStyle: {},
  voiceButtonDisabledStyle: {},
  chatIconStyle: {},
  audioIconStyle: {},
  audioIconDisabledStyle: {},
  closeChatIconStyle: {},
  emojiIconStyle: {},
  emojiIconDisabledStyle: {},
  fileAttachmentIconStyle: {},
  fileAttachmentIconDisabledStyle: {},
  notificationIconStyle: {},
  notificationIconDisabledStyle: {},
  voiceIconStyle: {},
  voiceIconDisabledStyle: {},
  sendIconStyle: {},
  sendIconDisabledStyle: {},
  sendIconHoveredStyle: {},
  rcbTypingIndicatorContainerStyle: {},
  rcbTypingIndicatorDotStyle: {},
  toastPromptContainerStyle: {},
  toastPromptStyle: {},
  toastPromptHoveredStyle: {}
}, ie = vA({
  styles: {},
  setSyncedStyles: () => null,
  syncedStylesRef: { current: {} }
}), X = () => hA(ie), et = ({
  children: A,
  styles: e = ce,
  setSyncedStyles: o,
  syncedStylesRef: t
}) => /* @__PURE__ */ l(ie.Provider, { value: { styles: e, setSyncedStyles: o, syncedStylesRef: t }, children: A }), tt = ({ buttons: A }) => {
  var n, s, a, r, c, i, u;
  const { settings: e } = N(), { styles: o } = X(), t = {
    backgroundImage: `linear-gradient(to right, ${(n = e.general) == null ? void 0 : n.secondaryColor},
			${(s = e.general) == null ? void 0 : s.primaryColor})`,
    ...o.headerStyle
  };
  return /* @__PURE__ */ W("div", { style: t, className: "rcb-chat-header-container", children: [
    /* @__PURE__ */ W("div", { className: "rcb-chat-header", children: [
      ((a = e.header) == null ? void 0 : a.showAvatar) && /* @__PURE__ */ l(
        "div",
        {
          style: { backgroundImage: `url("${(r = e.header) == null ? void 0 : r.avatar}")` },
          className: "rcb-bot-avatar"
        }
      ),
      UA((c = e.header) == null ? void 0 : c.title) ? (i = e.header) == null ? void 0 : i.title : /* @__PURE__ */ l("div", { style: { margin: 0, fontSize: 20, fontWeight: "bold" }, children: (u = e.header) == null ? void 0 : u.title })
    ] }),
    /* @__PURE__ */ l("div", { className: "rcb-chat-header", children: A == null ? void 0 : A.map(
      (f, w) => /* @__PURE__ */ l(jA, { children: f }, w)
    ) })
  ] });
}, le = vA({}), _ = () => hA(le), ot = ({
  children: A,
  botIdRef: e,
  flowRef: o
}) => {
  const t = $(null), n = $(""), s = $(null), a = $(/* @__PURE__ */ new Map()), r = $(null), c = $(""), i = $(!1), u = $(null), f = $(null), w = $(null);
  return /* @__PURE__ */ l(le.Provider, { value: {
    botIdRef: e,
    flowRef: o,
    inputRef: t,
    timeoutIdRef: s,
    streamMessageMap: a,
    chatBodyRef: r,
    paramsInputRef: c,
    keepVoiceOnRef: i,
    audioContextRef: u,
    audioBufferRef: f,
    gainNodeRef: w,
    prevInputRef: n
  }, children: A });
}, rA = (A) => {
  const [e, o] = z(A), t = $(A);
  return [e, (s) => {
    const a = typeof s == "function" ? s(t.current) : s;
    t.current = a, o(a);
  }, t];
}, ue = vA({}), AA = () => hA(ue), nt = ({
  children: A,
  settings: e
}) => {
  var nA, sA, CA, VA, ZA, _A;
  const [o, t, n] = rA(!1), [s, a, r] = rA(
    ((nA = e == null ? void 0 : e.chatWindow) == null ? void 0 : nA.defaultOpen) ?? !1
  ), [c, i, u] = rA(
    ((sA = e == null ? void 0 : e.audio) == null ? void 0 : sA.defaultToggledOn) ?? !1
  ), [f, w, d] = rA(
    ((CA = e == null ? void 0 : e.voice) == null ? void 0 : CA.defaultToggledOn) ?? !1
  ), [
    g,
    B,
    v
  ] = rA(
    ((VA = e == null ? void 0 : e.notification) == null ? void 0 : VA.defaultToggledOn) ?? !0
  ), [S, C] = z(!1), [h, P] = z(!1), [D, y, b] = rA(!1), [T, O, Q] = rA(!0), [
    E,
    m,
    p
  ] = rA(!1), [M, k] = z(!1), [I, L] = z(!1), [Y, K] = z(0), [G, R] = z(0), [q, F] = z(!1), [j, U] = z(((ZA = window.visualViewport) == null ? void 0 : ZA.height) ?? window.innerHeight), [eA, tA] = z(((_A = window.visualViewport) == null ? void 0 : _A.width) ?? window.innerWidth);
  return J(() => {
    const Te = localStorage.getItem("React-chatbotify-is-chat-window-open");
    I && a(Te === "true");
  }, []), J(() => {
    localStorage.setItem("React-chatbotify-is-chat-window-open", s.toString());
  }, [s]), /* @__PURE__ */ l(ue.Provider, { value: {
    isBotTyping: o,
    setSyncedIsBotTyping: t,
    syncedIsBotTypingRef: n,
    isChatWindowOpen: s,
    setSyncedIsChatWindowOpen: a,
    syncedIsChatWindowOpenRef: r,
    audioToggledOn: c,
    setSyncedAudioToggledOn: i,
    syncedAudioToggledOnRef: u,
    voiceToggledOn: f,
    setSyncedVoiceToggledOn: w,
    syncedVoiceToggledOnRef: d,
    notificationsToggledOn: g,
    setSyncedNotificationsToggledOn: B,
    syncedNotificationsToggledOnRef: v,
    isLoadingChatHistory: S,
    setIsLoadingChatHistory: C,
    hasChatHistoryLoaded: h,
    setHasChatHistoryLoaded: P,
    isScrolling: D,
    setSyncedIsScrolling: y,
    syncedIsScrollingRef: b,
    textAreaDisabled: T,
    setSyncedTextAreaDisabled: O,
    syncedTextAreaDisabledRef: Q,
    textAreaSensitiveMode: E,
    setSyncedTextAreaSensitiveMode: m,
    syncedTextAreaSensitiveModeRef: p,
    hasInteractedPage: M,
    setHasInteractedPage: k,
    hasFlowStarted: I,
    setHasFlowStarted: L,
    unreadCount: Y,
    setUnreadCount: K,
    inputLength: G,
    setInputLength: R,
    blockAllowsAttachment: q,
    setBlockAllowsAttachment: F,
    viewportHeight: j,
    setViewportHeight: U,
    viewportWidth: eA,
    setViewportWidth: tA
  }, children: A });
};
var x = /* @__PURE__ */ ((A) => (A.START_SPEAK_AUDIO = "rcb-start-speak-audio", A.TOGGLE_AUDIO = "rcb-toggle-audio", A.TOGGLE_NOTIFICATIONS = "rcb-toggle-notifications", A.TOGGLE_VOICE = "rcb-toggle-voice", A.TOGGLE_CHAT_WINDOW = "rcb-toggle-chat-window", A.PRE_INJECT_MESSAGE = "rcb-pre-inject-message", A.POST_INJECT_MESSAGE = "rcb-post-inject-message", A.START_SIMULATE_STREAM_MESSAGE = "rcb-start-simulate-stream-message", A.STOP_SIMULATE_STREAM_MESSAGE = "rcb-stop-simulate-stream-message", A.START_STREAM_MESSAGE = "rcb-start-stream-message", A.CHUNK_STREAM_MESSAGE = "rcb-chunk-stream-message", A.STOP_STREAM_MESSAGE = "rcb-stop-stream-message", A.REMOVE_MESSAGE = "rcb-remove-message", A.LOAD_CHAT_HISTORY = "rcb-load-chat-history", A.CHANGE_PATH = "rcb-change-path", A.SHOW_TOAST = "rcb-show-toast", A.DISMISS_TOAST = "rcb-dismiss-toast", A.USER_SUBMIT_TEXT = "rcb-user-submit-text", A.USER_UPLOAD_FILE = "rcb-user-upload-file", A.TEXT_AREA_CHANGE_VALUE = "rcb-text-area-change-value", A.PRE_LOAD_CHATBOT = "rcb-pre-load-chatbot", A.POST_LOAD_CHATBOT = "rcb-post-load-chatbot", A.PRE_PROCESS_BLOCK = "rcb-pre-process-block", A.POST_PROCESS_BLOCK = "rcb-post-process-block", A))(x || {});
const st = {
  [x.START_SPEAK_AUDIO]: !0,
  [x.TOGGLE_AUDIO]: !0,
  [x.TOGGLE_VOICE]: !0,
  [x.TOGGLE_NOTIFICATIONS]: !0,
  [x.TOGGLE_CHAT_WINDOW]: !0,
  [x.PRE_INJECT_MESSAGE]: !0,
  [x.POST_INJECT_MESSAGE]: !1,
  [x.PRE_LOAD_CHATBOT]: !0,
  [x.POST_LOAD_CHATBOT]: !1,
  [x.START_SIMULATE_STREAM_MESSAGE]: !0,
  [x.STOP_SIMULATE_STREAM_MESSAGE]: !1,
  [x.START_STREAM_MESSAGE]: !0,
  [x.CHUNK_STREAM_MESSAGE]: !0,
  [x.STOP_STREAM_MESSAGE]: !0,
  [x.REMOVE_MESSAGE]: !0,
  [x.LOAD_CHAT_HISTORY]: !0,
  [x.CHANGE_PATH]: !0,
  [x.SHOW_TOAST]: !0,
  [x.DISMISS_TOAST]: !0,
  [x.USER_SUBMIT_TEXT]: !0,
  [x.USER_UPLOAD_FILE]: !0,
  [x.TEXT_AREA_CHANGE_VALUE]: !0,
  [x.PRE_PROCESS_BLOCK]: !0,
  [x.POST_PROCESS_BLOCK]: !0
}, RA = async (A, e, o) => {
  const t = new CustomEvent(A, {
    detail: e,
    cancelable: st[A]
  });
  return t.data = o, t.promises = [], window.dispatchEvent(t), await Promise.all(t.promises), t;
}, fe = vA({
  paths: [],
  setSyncedPaths: () => {
  },
  syncedPathsRef: { current: [] }
}), QA = () => hA(fe), rt = ({ children: A }) => {
  const [e, o, t] = rA([]);
  return /* @__PURE__ */ l(fe.Provider, { value: { paths: e, setSyncedPaths: o, syncedPathsRef: t }, children: A });
}, lA = () => {
  const { botIdRef: A } = _(), { syncedPathsRef: e } = QA(), o = H(() => e.current.length > 0 ? e.current.at(-1) ?? null : null, []), t = H(() => e.current.length > 1 ? e.current.at(-2) ?? null : null, []);
  return { dispatchRcbEvent: H(async (s, a) => {
    const r = { botId: A.current, currPath: o(), prevPath: t() };
    return await RA(s, r, a);
  }, [A]) };
}, aA = () => {
  const { settings: A } = N(), {
    isChatWindowOpen: e,
    setSyncedIsChatWindowOpen: o,
    viewportHeight: t,
    setViewportHeight: n,
    viewportWidth: s,
    setViewportWidth: a,
    setUnreadCount: r,
    setSyncedIsBotTyping: c,
    setSyncedIsScrolling: i,
    syncedIsBotTypingRef: u,
    syncedIsChatWindowOpenRef: f
  } = AA(), { chatBodyRef: w } = _(), { dispatchRcbEvent: d } = lA(), g = H(() => {
    if (!w.current)
      return !1;
    const h = w.current.getBoundingClientRect(), P = window.innerHeight ?? document.documentElement.clientHeight, D = window.innerWidth ?? document.documentElement.clientWidth;
    return h.top >= 0 && h.left >= 0 && h.bottom <= P && h.right <= D;
  }, [w]), B = H(async (h) => {
    var P;
    h !== f.current && ((P = A.event) != null && P.rcbToggleChatWindow && (await d(
      x.TOGGLE_CHAT_WINDOW,
      {
        currState: f.current,
        newState: !f.current
      }
    )).defaultPrevented || o((D) => (D || r(0), localStorage.setItem("React-chatbotify-is-chat-window-open", (!D).toString()), !D)));
  }, [f]), v = H(async (h) => {
    h !== u.current && c((P) => !P);
  }, [u]), S = H((h, P, D, y) => (h /= y / 2, h < 1 ? D / 2 * h * h + P : (h--, -D / 2 * (h * (h - 2) - 1) + P)), []), C = H((h = 0) => {
    if (!w.current)
      return;
    const P = w.current.scrollHeight - w.current.clientHeight;
    if (h <= 0) {
      w.current.scrollTop = P, i(!1);
      return;
    }
    const D = w.current.scrollTop, y = P - D, b = 20;
    let T = 0;
    const O = () => {
      if (!w.current)
        return;
      T += b;
      const Q = S(T, D, y, h);
      w.current.scrollTop = Q, T < h ? requestAnimationFrame(O) : i(!1);
    };
    O();
  }, [w]);
  return {
    isChatWindowOpen: e,
    setSyncedIsChatWindowOpen: o,
    toggleChatWindow: B,
    viewportHeight: t,
    setViewportHeight: n,
    viewportWidth: s,
    setViewportWidth: a,
    toggleIsBotTyping: v,
    scrollToBottom: C,
    getIsChatBotVisible: g
  };
}, at = () => {
  var w, d, g;
  const { settings: A } = N(), { styles: e } = X(), { unreadCount: o, isScrolling: t } = AA(), { chatBodyRef: n } = _(), { scrollToBottom: s } = aA(), [a, r] = z(!1), c = {
    color: (w = A.general) == null ? void 0 : w.primaryColor,
    borderColor: (d = A.general) == null ? void 0 : d.primaryColor,
    ...e.chatMessagePromptHoveredStyle
  }, i = () => {
    r(!0);
  }, u = () => {
    r(!1);
  };
  return /* @__PURE__ */ l("div", { className: `rcb-message-prompt-container ${(() => {
    var v;
    return n.current && ((v = A.chatWindow) == null ? void 0 : v.showMessagePrompt) && t && o > 0 ? "visible" : "hidden";
  })()}`, children: /* @__PURE__ */ l(
    "div",
    {
      onMouseEnter: i,
      onMouseLeave: u,
      style: a ? c : { ...e.chatMessagePromptStyle },
      onMouseDown: (B) => {
        B.preventDefault(), s(600);
      },
      className: "rcb-message-prompt-text",
      children: (g = A.chatWindow) == null ? void 0 : g.messagePromptText
    }
  ) });
}, de = vA({
  messages: [],
  setSyncedMessages: () => {
  },
  syncedMessagesRef: { current: [] }
}), zA = () => hA(de), ct = ({ children: A }) => {
  const [e, o, t] = rA([]);
  return /* @__PURE__ */ l(de.Provider, { value: { messages: e, setSyncedMessages: o, syncedMessagesRef: t }, children: A });
}, it = ({
  message: A,
  isNewSender: e
}) => {
  var f, w, d, g, B, v;
  const { settings: o } = N(), { styles: t } = X(), n = typeof A.content == "string", s = A.content, a = A.contentWrapper ? /* @__PURE__ */ l(A.contentWrapper, { children: s }) : s, r = {
    backgroundColor: (f = o.general) == null ? void 0 : f.primaryColor,
    color: "#fff",
    maxWidth: (w = o.userBubble) != null && w.showAvatar ? "65%" : "70%",
    ...t.userBubbleStyle
  }, c = (d = o.userBubble) != null && d.animate ? "rcb-user-message-entry" : "", i = ((g = o.userBubble) == null ? void 0 : g.showAvatar) && e, u = `rcb-user-message${!e && ((B = o.userBubble) != null && B.showAvatar) ? " rcb-user-message-offset" : ""}`;
  return /* @__PURE__ */ W("div", { className: "rcb-user-message-container", children: [
    n ? /* @__PURE__ */ l("div", { style: r, className: `${u} ${c}`, children: a }) : /* @__PURE__ */ l(oA, { children: a }),
    i && /* @__PURE__ */ l(
      "div",
      {
        style: { backgroundImage: `url("${(v = o.userBubble) == null ? void 0 : v.avatar}")` },
        className: "rcb-message-user-avatar"
      }
    )
  ] });
}, lt = ({
  message: A,
  isNewSender: e
}) => {
  var f, w, d, g, B, v;
  const { settings: o } = N(), { styles: t } = X(), n = typeof A.content == "string", s = A.content, a = A.contentWrapper ? /* @__PURE__ */ l(A.contentWrapper, { children: s }) : s, r = {
    backgroundColor: (f = o.general) == null ? void 0 : f.secondaryColor,
    color: "#fff",
    maxWidth: (w = o.botBubble) != null && w.showAvatar ? "65%" : "70%",
    ...t.botBubbleStyle
  }, c = (d = o.botBubble) != null && d.animate ? "rcb-bot-message-entry" : "", i = ((g = o.botBubble) == null ? void 0 : g.showAvatar) && e, u = `rcb-bot-message${!e && ((B = o.botBubble) != null && B.showAvatar) ? " rcb-bot-message-offset" : ""}`;
  return /* @__PURE__ */ W("div", { className: "rcb-bot-message-container", children: [
    i && /* @__PURE__ */ l(
      "div",
      {
        style: { backgroundImage: `url("${(v = o.botBubble) == null ? void 0 : v.avatar}")` },
        className: "rcb-message-bot-avatar"
      }
    ),
    n ? /* @__PURE__ */ l("div", { style: r, className: `${u} ${c}`, children: a }) : /* @__PURE__ */ l(oA, { children: a })
  ] });
}, ut = () => {
  var t, n, s;
  const { settings: A } = N(), { styles: e } = X(), o = (t = A.botBubble) != null && t.animate ? "rcb-bot-message-entry" : "";
  return /* @__PURE__ */ W("div", { className: "rcb-bot-message-container", children: [
    ((n = A.botBubble) == null ? void 0 : n.showAvatar) && /* @__PURE__ */ l(
      "div",
      {
        style: { backgroundImage: `url("${(s = A.botBubble) == null ? void 0 : s.avatar}")` },
        className: "rcb-message-bot-avatar"
      }
    ),
    /* @__PURE__ */ l(
      "div",
      {
        onMouseDown: (a) => {
          a.preventDefault();
        },
        className: `rcb-bot-message ${o}`,
        children: /* @__PURE__ */ W("div", { className: "rcb-typing-indicator", style: { ...e == null ? void 0 : e.rcbTypingIndicatorContainerStyle }, children: [
          /* @__PURE__ */ l("span", { className: "rcb-dot", style: { ...e == null ? void 0 : e.rcbTypingIndicatorDotStyle } }),
          /* @__PURE__ */ l("span", { className: "rcb-dot", style: { ...e == null ? void 0 : e.rcbTypingIndicatorDotStyle } }),
          /* @__PURE__ */ l("span", { className: "rcb-dot", style: { ...e == null ? void 0 : e.rcbTypingIndicatorDotStyle } })
        ] })
      }
    )
  ] });
}, ft = () => {
  var i, u, f;
  const { settings: A } = N(), { styles: e } = X(), { messages: o } = zA(), { scrollToBottom: t } = aA(), {
    isBotTyping: n,
    syncedIsScrollingRef: s
  } = AA(), { chatBodyRef: a } = _(), r = {
    ...e == null ? void 0 : e.bodyStyle,
    scrollbarWidth: (i = A.chatWindow) != null && i.showScrollbar ? "auto" : "none"
  };
  J(() => {
    s.current || t();
  }, [(u = a.current) == null ? void 0 : u.scrollHeight]);
  const c = (w) => w === 0 ? !0 : o[w].sender !== o[w - 1].sender;
  return /* @__PURE__ */ W(
    "div",
    {
      style: r,
      className: "rcb-chat-body-container",
      ref: a,
      children: [
        o.map((w, d) => {
          const g = c(d);
          return w.sender.toUpperCase() === "USER" ? /* @__PURE__ */ l(it, { message: w, isNewSender: g }, d) : w.sender.toUpperCase() === "BOT" ? /* @__PURE__ */ l(lt, { message: w, isNewSender: g }, d) : /* @__PURE__ */ l("div", { children: w.content }, d);
        }),
        n && ((f = A.chatWindow) == null ? void 0 : f.showTypingIndicator) && /* @__PURE__ */ l(ut, {}),
        /* @__PURE__ */ l(at, {})
      ]
    }
  );
}, dt = ({
  checkboxes: A,
  checkedItems: e,
  path: o
}) => {
  var v, S, C, h, P, D, y, b, T, O, Q;
  const { settings: t } = N(), { styles: n } = X(), { paths: s } = QA(), { handleSubmitText: a } = yA(), [r, c] = z(/* @__PURE__ */ new Set()), [i, u] = z(!1), f = {
    cursor: i ? `url("${(v = t.general) == null ? void 0 : v.actionDisabledIcon}"), auto` : "pointer",
    color: (S = t.general) == null ? void 0 : S.primaryColor,
    borderColor: (C = t.general) == null ? void 0 : C.primaryColor,
    ...n.botCheckboxRowStyle
  }, w = {
    cursor: i || r.size < A.min ? `url("${(h = t.general) == null ? void 0 : h.actionDisabledIcon}"), auto` : "pointer",
    color: (P = t.general) == null ? void 0 : P.primaryColor,
    borderColor: (D = t.general) == null ? void 0 : D.primaryColor,
    ...n.botCheckboxNextStyle
  }, d = {
    cursor: i ? `url("${(y = t.general) == null ? void 0 : y.actionDisabledIcon}"), auto` : "pointer",
    color: "transparent",
    ...n.botCheckMarkStyle
  }, g = {
    cursor: i ? `url("${(b = t.general) == null ? void 0 : b.actionDisabledIcon}"), auto` : "pointer",
    color: "#fff",
    borderColor: (T = t.general) == null ? void 0 : T.primaryColor,
    backgroundColor: (O = t.general) == null ? void 0 : O.primaryColor,
    ...n.botCheckMarkSelectedStyle
  };
  J(() => {
    s.length > 0 && s[s.length - 1] !== o && u(!A.reusable);
  }, [s]);
  const B = (E) => {
    i || c((m) => {
      const p = new Set(m);
      if (p.has(E))
        e.delete(E), p.delete(E);
      else {
        if (r.size == A.max)
          return m;
        e.add(E), p.add(E);
      }
      return p;
    });
  };
  return /* @__PURE__ */ W("div", { className: `rcb-checkbox-container ${(Q = t.botBubble) != null && Q.showAvatar ? "rcb-checkbox-offset" : ""}`, children: [
    A.items.map((E) => /* @__PURE__ */ l(
      "div",
      {
        onMouseDown: (m) => {
          m.preventDefault(), B(E);
        },
        style: f,
        className: "rcb-checkbox-row-container",
        children: /* @__PURE__ */ W("div", { className: "rcb-checkbox-row", children: [
          /* @__PURE__ */ l(
            "div",
            {
              style: r.has(E) ? g : d,
              className: "rcb-checkbox-mark"
            }
          ),
          /* @__PURE__ */ l("div", { className: "rcb-checkbox-label", children: E })
        ] })
      },
      E
    )),
    /* @__PURE__ */ l(
      "div",
      {
        style: w,
        className: "rcb-checkbox-next-button",
        onMouseDown: (E) => {
          var M;
          if (E.preventDefault(), i || r.size < A.min)
            return;
          const m = Array.from(e).join(", ");
          u(!A.reusable);
          let p;
          A.sendOutput != null ? p = A.sendOutput : p = ((M = t.chatInput) == null ? void 0 : M.sendCheckboxOutput) ?? !0, a(m, p);
        }
      }
    )
  ] });
}, wt = async (A, e) => {
  const o = A.checkboxes;
  if (!o)
    return;
  let t;
  if (typeof o == "function" ? (t = o(e), t instanceof Promise && (t = await t)) : t = o, Array.isArray(t) && (t = { items: t }), !("items" in t) || t.items.length == 0)
    return;
  t.min == null && (t.min = 1), t.max == null && (t.max = t.items.length), t.min > t.max && (t.min = t.max), t.reusable == null && (t.reusable = !1);
  const n = /* @__PURE__ */ new Set(), s = e.currPath, a = /* @__PURE__ */ l(dt, { checkboxes: t, checkedItems: n, path: s });
  await e.injectMessage(a);
}, gt = async (A, e) => {
  const o = A.function;
  if (!o)
    return;
  const t = o(e);
  return t instanceof Promise ? await t : t;
}, Bt = async (A, e, o) => {
  const t = A.message;
  if (!t)
    return;
  if (typeof t == "string") {
    t.trim() !== "" && (o ? await e.simulateStreamMessage(t) : await e.injectMessage(t));
    return;
  }
  let n = t(e);
  n instanceof Promise && (n = await n), typeof n == "string" && n.trim() !== "" && (o ? await e.simulateStreamMessage(n) : await e.injectMessage(n));
}, vt = ({
  options: A,
  path: e
}) => {
  var g, B, v, S, C, h;
  const { settings: o } = N(), { styles: t } = X(), { paths: n } = QA(), { handleSubmitText: s } = yA(), [a, r] = z([]), [c, i] = z(!1), u = {
    cursor: c ? `url("${(g = o.general) == null ? void 0 : g.actionDisabledIcon}"), auto` : "pointer",
    color: (B = o.general) == null ? void 0 : B.primaryColor,
    borderColor: (v = o.general) == null ? void 0 : v.primaryColor,
    backgroundColor: "#fff",
    ...t.botOptionStyle
  }, f = {
    color: "#fff",
    borderColor: (S = o.general) == null ? void 0 : S.primaryColor,
    backgroundColor: (C = o.general) == null ? void 0 : C.primaryColor,
    ...t.botOptionHoveredStyle
  };
  J(() => {
    n.length > 0 && n[n.length - 1] !== e && i(!A.reusable);
  }, [n]);
  const w = (P) => {
    r((D) => {
      const y = [...D];
      return y[P] = !0, y;
    });
  }, d = (P) => {
    r((D) => {
      const y = [...D];
      return y[P] = !1, y;
    });
  };
  return /* @__PURE__ */ l("div", { className: `rcb-options-container ${(h = o.botBubble) != null && h.showAvatar ? "rcb-options-offset" : ""}`, children: A.items.map((P, D) => {
    const y = a[D] && !c;
    return /* @__PURE__ */ l(
      "div",
      {
        className: "rcb-options",
        style: y ? f : u,
        onMouseEnter: () => w(D),
        onMouseLeave: () => d(D),
        onMouseDown: (b) => {
          var O;
          if (b.preventDefault(), c)
            return;
          i(!A.reusable);
          let T;
          A.sendOutput != null ? T = A.sendOutput : T = ((O = o.chatInput) == null ? void 0 : O.sendOptionOutput) ?? !0, s(P, T);
        },
        children: P
      },
      P
    );
  }) });
}, ht = async (A, e) => {
  const o = A.options;
  if (!o)
    return;
  let t;
  if (typeof o == "function" ? (t = o(e), t instanceof Promise && (t = await t)) : t = o, Array.isArray(t) && (t = { items: t }), !("items" in t) || t.items.length == 0)
    return;
  t.reusable == null && (t.reusable = !1);
  const n = e.currPath, s = /* @__PURE__ */ l(vt, { options: t, path: n });
  await e.injectMessage(s);
}, Pt = async (A, e) => {
  const o = A.path;
  if (!o)
    return !1;
  if (typeof o == "string")
    return await e.goToPath(o), !0;
  let t = o(e);
  if (t instanceof Promise && (t = await t), !t)
    return !1;
  const n = t;
  return await e.goToPath(n), !0;
}, Dt = async (A, e) => {
  const o = A.component;
  if (o) {
    if (typeof o == "function") {
      let t = o(e);
      if (t instanceof Promise && (t = await t), !t)
        return;
      await e.injectMessage(t);
      return;
    }
    await e.injectMessage(o);
  }
}, Et = async (A, e, o, t) => {
  const n = A.transition;
  let s;
  if (typeof n == "function" ? (s = n(e), s instanceof Promise && (s = await s)) : s = n, typeof s == "number" && (s = { duration: s }), !s || s instanceof Promise || s.duration == null || typeof s.duration != "number")
    return;
  s.interruptable == null && (s.interruptable = !1);
  const a = setTimeout(async () => {
    const r = await t(A);
    r && await ge(r, e);
  }, s.duration);
  s.interruptable && (o.current = a);
}, yt = async (A, e, o) => {
  const t = A.chatDisabled;
  if (t == null)
    return;
  let n;
  typeof t == "function" ? (n = t(e), n instanceof Promise && (n = await n)) : n = t, o(n);
}, we = async (A, e, o) => {
  const t = A.isSensitive;
  if (!t) {
    o(!1);
    return;
  }
  let n;
  typeof t == "function" ? (n = t(e), n instanceof Promise && (n = await n)) : n = t, o(n);
}, Ct = async (A, e, o, t, n, s, a) => {
  if (!A)
    throw new Error("Block is not valid.");
  for (const r of Object.keys(A))
    switch (r) {
      case "message":
        await Bt(A, e, o);
        break;
      case "options":
        await ht(A, e);
        break;
      case "checkboxes":
        await wt(A, e);
        break;
      case "component":
        await Dt(A, e);
        break;
      case "chatDisabled":
        await yt(A, e, n);
        break;
      case "isSensitive":
        await we(A, e, s);
        break;
      case "transition":
        await Et(A, e, t, a);
    }
}, ge = async (A, e) => {
  if (!A)
    throw new Error("Block is not valid.");
  const o = Object.keys(A);
  for (const t of o)
    t === "function" && await gt(A, e);
  o.includes("path") && await Pt(A, e);
}, mt = () => {
  var o;
  const { settings: A } = N(), { styles: e } = X();
  return /* @__PURE__ */ l("div", { className: "rcb-line-break-container", children: /* @__PURE__ */ l(
    "div",
    {
      style: { ...e.chatHistoryLineBreakStyle },
      className: "rcb-line-break-text",
      "data-testid": "chat-history-line-break-text",
      children: (o = A.chatHistory) == null ? void 0 : o.chatHistoryLineBreakText
    }
  ) });
}, Qt = () => {
  var t;
  const { settings: A } = N(), { styles: e } = X(), o = {
    borderTop: `4px solid ${(t = A.general) == null ? void 0 : t.primaryColor}`,
    ...e.loadingSpinnerStyle
  };
  return /* @__PURE__ */ l("div", { className: "rcb-spinner-container", children: /* @__PURE__ */ l("div", { style: o, className: "rcb-spinner" }) });
}, IA = () => {
  try {
    if (typeof crypto < "u" && typeof crypto.randomUUID == "function")
      return crypto.randomUUID();
    throw new Error("crypto.randomUUID not available");
  } catch (A) {
    if (typeof crypto < "u" && typeof crypto.getRandomValues == "function")
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
        const o = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
        return (e === "x" ? o : o & 3 | 8).toString(16);
      });
    throw console.error(A), new Error("crypto.getRandomValues is also not available");
  }
}, gA = (A, e) => ({
  id: IA(),
  content: A,
  sender: e,
  type: typeof A == "string" ? "string" : "object",
  timestamp: (/* @__PURE__ */ new Date()).toUTCString(),
  tags: []
});
let wA, Be = !1, TA = "rcb-history", pA = 30, ve = !1, mA = [];
const xA = async (A) => {
  if (ve || !wA)
    return;
  const e = [], o = Be ? mA.length : 0;
  for (let n = A.length - 1; n >= o; n--) {
    const s = A[n];
    if (s.sender.toUpperCase() !== "SYSTEM" && (s.content !== "" && e.unshift(s), e.length === pA))
      break;
  }
  let t = e.map(It);
  if (t.length < pA) {
    const n = pA - t.length;
    t = [...mA.slice(-n), ...t];
  }
  he(t);
}, bt = (A) => {
  if (A != null)
    try {
      return JSON.parse(A);
    } catch {
      return [];
    }
  return [];
}, GA = () => mA, pt = (A) => {
  he(A), mA = A;
}, he = (A) => {
  wA && wA.setItem(TA, JSON.stringify(A));
}, St = () => {
  wA && wA.removeItem(TA);
}, FA = (A) => {
  var e, o, t, n, s;
  ((o = (e = A.chatHistory) == null ? void 0 : e.storageType) == null ? void 0 : o.toUpperCase()) === "SESSION_STORAGE" ? wA = sessionStorage : wA = localStorage, TA = (t = A.chatHistory) == null ? void 0 : t.storageKey, pA = (n = A.chatHistory) == null ? void 0 : n.maxEntries, ve = (s = A.chatHistory) == null ? void 0 : s.disabled, mA = bt(wA.getItem(TA));
}, It = (A) => UA(A.content) ? structuredClone({
  id: A.id,
  content: Me.renderToString(A.content),
  type: A.type,
  sender: A.sender.toUpperCase(),
  timestamp: A.timestamp,
  tags: A.tags
}) : A, Tt = (A, e, o, t, n, s, a, r, c) => {
  var i;
  if (Be = !0, o != null)
    try {
      const u = gA(/* @__PURE__ */ l(Qt, {}), "SYSTEM"), f = n.current.slice(1);
      t([u, ...f]);
      const w = o.map((d) => {
        if (d.type === "object") {
          const g = Pe(d.content, A, e);
          return { ...d, content: g };
        }
        return d;
      });
      setTimeout(() => {
        var B;
        const d = n.current.slice(1);
        let g = (B = A.chatHistory) != null && B.autoLoad ? gA(/* @__PURE__ */ l(oA, {}), "SYSTEM") : gA(/* @__PURE__ */ l(mt, {}), "SYSTEM");
        t([...w, g, ...d]), c(!0);
      }, 500), setTimeout(() => {
        if (!s.current)
          return;
        const { scrollHeight: d } = s.current, g = d - a;
        s.current.scrollTop += g, r(!1);
      }, 510);
    } catch {
      wA.removeItem((i = A.chatHistory) == null ? void 0 : i.storageKey);
    }
}, Pe = (A, e, o) => {
  const n = new DOMParser().parseFromString(A, "text/html");
  return Array.from(n.body.childNodes).map((r, c) => {
    var i;
    if (r.nodeType === Node.TEXT_NODE)
      return r.textContent;
    {
      const u = r.tagName.toLowerCase();
      let f = Array.from(r.attributes).reduce((d, g) => {
        const B = g.name.toLowerCase();
        if (B === "style") {
          const v = g.value.split(";").filter((C) => C.trim() !== ""), S = {};
          v.forEach((C) => {
            const [h, P] = C.split(":").map((y) => y.trim()), D = h.replace(/-([a-z])/g, (y, b) => b.toUpperCase());
            S[D] = P;
          }), d[B] = S;
        } else (u === "audio" || u === "video") && B === "controls" && g.value === "" ? d[B] = "true" : d[B] = g.value;
        return d;
      }, {});
      if (Object.prototype.hasOwnProperty.call(f, "class")) {
        const d = r.classList;
        f.className = d.toString(), delete f.class, (i = e.botBubble) != null && i.showAvatar && (f = Mt(d, f)), f = kt(d, f, e, o), f = Ht(d, f, e, o), f = xt(d, f, e, o), f = Ot(d, f, e, o);
      }
      if ([
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "link",
        "meta",
        "source",
        "track",
        "wbr"
      ].includes(u))
        return $A(u, { key: c, ...f });
      {
        const d = Pe(r.innerHTML, e, o);
        return $A(u, { key: c, ...f }, ...d);
      }
    }
  });
}, Mt = (A, e) => ((A.contains("rcb-options-container") || A.contains("rcb-checkbox-container")) && (e.className = `${A.toString()} rcb-options-offset`), e), kt = (A, e, o, t) => {
  var n, s, a, r, c;
  return A.contains("rcb-options") && (e.style = {
    ...e.style,
    color: ((n = t.botOptionStyle) == null ? void 0 : n.color) ?? ((s = o.general) == null ? void 0 : s.primaryColor),
    borderColor: ((a = t.botOptionStyle) == null ? void 0 : a.color) ?? ((r = o.general) == null ? void 0 : r.primaryColor),
    cursor: `url("${(c = o.general) == null ? void 0 : c.actionDisabledIcon}"), auto`,
    ...t.botOptionStyle
  }), e;
}, Ht = (A, e, o, t) => {
  var n, s, a, r, c;
  return A.contains("rcb-checkbox-row-container") && (e.style = {
    ...e.style,
    color: ((n = t.botCheckboxRowStyle) == null ? void 0 : n.color) ?? ((s = o.general) == null ? void 0 : s.primaryColor),
    borderColor: ((a = t.botCheckboxRowStyle) == null ? void 0 : a.color) ?? ((r = o.general) == null ? void 0 : r.primaryColor),
    cursor: `url("${(c = o.general) == null ? void 0 : c.actionDisabledIcon}"), auto`,
    ...t.botCheckboxRowStyle
  }), e;
}, xt = (A, e, o, t) => {
  var n, s, a, r, c;
  return A.contains("rcb-checkbox-next-button") && (e.style = {
    ...e.style,
    color: ((n = t.botCheckboxNextStyle) == null ? void 0 : n.color) ?? ((s = o.general) == null ? void 0 : s.primaryColor),
    borderColor: ((a = t.botCheckboxNextStyle) == null ? void 0 : a.color) ?? ((r = o.general) == null ? void 0 : r.primaryColor),
    cursor: `url("${(c = o.general) == null ? void 0 : c.actionDisabledIcon}"), auto`,
    ...t.botCheckboxNextStyle
  }), e;
}, Ot = (A, e, o, t) => {
  var n, s;
  return (A.contains("rcb-media-display-image-container") || A.contains("rcb-media-display-video-container")) && (e.style = {
    ...e.style,
    backgroundColor: (n = o.general) == null ? void 0 : n.primaryColor,
    maxWidth: (s = o.userBubble) != null && s.showAvatar ? "65%" : "70%",
    ...t.mediaDisplayContainerStyle
  }), e;
}, YA = () => {
  const { settings: A } = N(), {
    notificationsToggledOn: e,
    setSyncedNotificationsToggledOn: o,
    hasInteractedPage: t,
    unreadCount: n,
    setUnreadCount: s,
    syncedNotificationsToggledOnRef: a
  } = AA(), { audioBufferRef: r, audioContextRef: c, gainNodeRef: i } = _(), { dispatchRcbEvent: u } = lA(), f = H(async () => {
    var S, C;
    const g = (S = A.notification) == null ? void 0 : S.sound;
    c.current = new AudioContext();
    const B = c.current.createGain();
    B.gain.value = ((C = A.notification) == null ? void 0 : C.volume) ?? 0.2, i.current = B;
    let v;
    if (g != null && g.startsWith("data:audio")) {
      const h = atob(g.split(",")[1]), P = new ArrayBuffer(h.length), D = new Uint8Array(P);
      for (let y = 0; y < h.length; y++)
        D[y] = h.charCodeAt(y);
      v = P;
    } else
      v = await (await fetch(g)).arrayBuffer();
    r.current = await c.current.decodeAudioData(v);
  }, [A.notification]), w = H(() => {
    var B;
    if ((B = A.notification) != null && B.disabled || !a.current || !t || !c.current || !r.current)
      return;
    const g = c.current.createBufferSource();
    g.buffer = r.current, g.connect(i.current).connect(c.current.destination), g.start();
  }, [
    A.notification,
    a,
    t,
    c,
    r,
    i
  ]), d = H(async (g) => {
    var B;
    g !== a.current && ((B = A.event) != null && B.rcbToggleNotifications && (await u(
      x.TOGGLE_NOTIFICATIONS,
      {
        currState: a.current,
        newState: !a.current
      }
    )).defaultPrevented || o((v) => !v));
  }, [a]);
  return {
    unreadCount: n,
    setUnreadCount: s,
    notificationsToggledOn: e,
    toggleNotifications: d,
    playNotificationSound: w,
    setUpNotifications: f
  };
}, Lt = (A, e, o, t, n) => {
  if (!window.SpeechSynthesisUtterance) {
    console.info("Speech Synthesis API is not supported in this environment.");
    return;
  }
  const s = new window.SpeechSynthesisUtterance();
  s.text = A, s.lang = e, s.rate = t, s.volume = n;
  let a = !1;
  for (const r of o) {
    const c = window.speechSynthesis.getVoices().find((i) => i.name === r);
    if (c) {
      s.voice = c, window.speechSynthesis.speak(s), a = !0;
      break;
    }
  }
  a || window.speechSynthesis.speak(s);
}, Nt = (A, e) => {
  var o, t, n, s;
  Lt(
    e,
    (o = A.audio) == null ? void 0 : o.language,
    (t = A.audio) == null ? void 0 : t.voiceNames,
    (n = A.audio) == null ? void 0 : n.rate,
    (s = A.audio) == null ? void 0 : s.volume
  );
}, XA = () => {
  const { settings: A } = N(), { audioToggledOn: e, setSyncedAudioToggledOn: o, syncedAudioToggledOnRef: t } = AA(), { dispatchRcbEvent: n } = lA(), s = H(async (r) => {
    var c;
    r !== t.current && ((c = A.event) != null && c.rcbToggleAudio && (await n(
      x.TOGGLE_AUDIO,
      {
        currState: t.current,
        newState: !t.current
      }
    )).defaultPrevented || o((i) => !i));
  }, [t]), a = H(async (r) => {
    var i, u;
    if ((i = A.audio) != null && i.disabled || !t.current)
      return;
    let c = r;
    if ((u = A.event) != null && u.rcbStartSpeakAudio) {
      const f = await n(x.START_SPEAK_AUDIO, { textToRead: c });
      if (f.defaultPrevented)
        return;
      c = f.data.textToRead;
    }
    Nt(A, c);
  }, [A, t]);
  return {
    audioToggledOn: e,
    speakAudio: a,
    toggleAudio: s
  };
}, PA = () => {
  var T, O;
  const { settings: A } = N(), { messages: e, setSyncedMessages: o, syncedMessagesRef: t } = zA(), {
    setSyncedIsBotTyping: n,
    setUnreadCount: s,
    syncedIsScrollingRef: a,
    syncedIsChatWindowOpenRef: r
  } = AA(), { streamMessageMap: c, chatBodyRef: i, paramsInputRef: u } = _(), { scrollToBottom: f, getIsChatBotVisible: w } = aA(), { dispatchRcbEvent: d } = lA(), { speakAudio: g } = XA(), { playNotificationSound: B } = YA(), v = H((Q, E = !1) => {
    var k, I;
    xA(Q);
    let m = !0;
    const p = Q[Q.length - 1];
    if (!p)
      return;
    const M = p.sender.toUpperCase();
    M === "USER" && (m = !1), (k = A.general) != null && k.embedded && w() && (m = !1), (r.current && !a.current || E) && (m = !1), m && B(), !E && (M !== "USER" && ((I = A.chatWindow) != null && I.autoJumpToBottom) || M === "USER" || !a.current) && setTimeout(() => f(), 1);
  }, [
    A,
    i,
    r,
    a,
    B,
    f,
    w
  ]), S = H(async (Q, E = "BOT", m = null) => {
    var G, R, q, F, j;
    if (typeof Q != "string")
      throw new Error("Content must be of type string to simulate stream.");
    E = E.toUpperCase();
    let p = gA(Q, E);
    if ((G = A.event) != null && G.rcbStartSimulateStreamMessage) {
      const U = await d(
        x.START_SIMULATE_STREAM_MESSAGE,
        { message: p }
      );
      if (U.defaultPrevented)
        return null;
      m = U.data.simulateStreamChunker || m, p = U.data.message;
    }
    n(!1);
    let M = 30;
    E === "BOT" ? M = (R = A.botBubble) == null ? void 0 : R.streamSpeed : M = (q = A.userBubble) == null ? void 0 : q.streamSpeed;
    const k = { ...p, content: "" };
    o((U) => [...U, k]), v(t.current);
    let I = p.content;
    m && (I = m(I));
    let L = 0;
    const Y = I.length;
    p.sender.toUpperCase() === "BOT" && (r.current || (F = A.general) != null && F.embedded) && typeof p.content == "string" && p.content.trim() !== "" && g(p.content);
    const K = new Promise((U) => {
      const eA = setInterval(() => {
        if (L >= Y) {
          clearInterval(eA), U();
          return;
        }
        o((tA) => {
          const nA = [...tA];
          for (let sA = nA.length - 1; sA >= 0; sA--)
            if (nA[sA].id === k.id) {
              const CA = I[L];
              CA && (k.content += CA, nA[sA] = k), L++;
              break;
            }
          return nA;
        });
      }, M);
    });
    return (a.current || !r.current) && s((U) => U + 1), await K, xA(t.current), (j = A.event) != null && j.rcbStopSimulateStreamMessage && await d(x.STOP_SIMULATE_STREAM_MESSAGE, { message: p }), E === "USER" && (u.current = Q), p;
  }, [
    A,
    d,
    v,
    t,
    u,
    n,
    s,
    r,
    g
  ]), C = H(async (Q, E = "BOT") => {
    var p, M, k;
    E = E.toUpperCase();
    let m = gA(Q, E);
    if ((p = A.event) != null && p.rcbPreInjectMessage) {
      const I = await d(x.PRE_INJECT_MESSAGE, { message: m });
      if (I.defaultPrevented)
        return null;
      m = I.data.message;
    }
    return m.sender.toUpperCase() === "BOT" && (r.current || (M = A.general) != null && M.embedded) && typeof m.content == "string" && m.content.trim() !== "" && g(m.content), (a.current || !r.current) && s((I) => I + 1), (k = A.event) != null && k.rcbPostInjectMessage && await d(x.POST_INJECT_MESSAGE, { message: m }), o((I) => [...I, m]), v(t.current), E === "USER" && typeof Q == "string" && (u.current = Q), m;
  }, [
    A,
    d,
    v,
    u,
    t,
    r,
    g,
    s
  ]), h = H(async (Q) => {
    var m;
    const E = t.current.find((p) => p.id === Q);
    return !E || (m = A.event) != null && m.rcbRemoveMessage && (await d(x.REMOVE_MESSAGE, { message: E })).defaultPrevented ? null : (o(
      (p) => p.filter((M) => M.id !== Q)
    ), v(t.current), s((p) => Math.max(p - 1, 0)), E);
  }, [
    d,
    (T = A.event) == null ? void 0 : T.rcbRemoveMessage,
    v,
    t,
    s
  ]), P = H(async (Q, E = "BOT") => {
    var p, M;
    if (E = E.toUpperCase(), !c.current.has(E)) {
      const k = gA(Q, E);
      return (p = A.event) != null && p.rcbStartStreamMessage && (await d(x.START_STREAM_MESSAGE, { message: k })).defaultPrevented ? null : (n(!1), o((I) => [...I, k]), v(t.current), c.current.set(E, k.id), (a.current || !r.current) && s((I) => I + 1), k);
    }
    const m = { ...gA(Q, E), id: c.current.get(E) };
    return (M = A.event) != null && M.rcbChunkStreamMessage && (await d(x.CHUNK_STREAM_MESSAGE, { message: m })).defaultPrevented ? null : (o(
      (k) => k.map((I) => I.id === m.id ? m : I)
    ), v(t.current, !0), m);
  }, [
    d,
    A.event,
    v,
    t,
    n,
    s,
    c
  ]), D = H(async (Q = "BOT") => {
    var p;
    if (Q = Q.toUpperCase(), !c.current.has(Q))
      return !0;
    const E = c.current.get(Q);
    let m;
    for (let M = 0; M < 3; M++) {
      const k = t.current.find((I) => I.id === E);
      k && (m = k), await new Promise((I) => setTimeout(I, 20));
    }
    return (p = A.event) != null && p.rcbStopStreamMessage && (await d(x.STOP_STREAM_MESSAGE, { message: m })).defaultPrevented ? !1 : (c.current.delete(Q), xA(t.current), Q === "USER" && typeof (m == null ? void 0 : m.content) == "string" && (u.current = m.content), !0);
  }, [d, (O = A.event) == null ? void 0 : O.rcbStopStreamMessage, c, u]), y = H((Q) => {
    const E = typeof Q == "function" ? Q(t.current) : Q;
    o(E), v(E);
  }, [v, t]), b = H(
    (Q, E, m = 0) => {
      var L;
      const p = t.current, M = Q ? Q.toUpperCase() : null, k = [];
      let I = m;
      for (let Y = p.length - 1; Y >= 0; Y--) {
        const K = p[Y];
        if (!M || ((L = K == null ? void 0 : K.sender) == null ? void 0 : L.toUpperCase()) === M) {
          if (I > 0) {
            I--;
            continue;
          }
          if (k.push(K), E !== void 0 && k.length === E)
            break;
        }
      }
      return k.length > 0 ? k : null;
    },
    [t]
  );
  return {
    simulateStreamMessage: S,
    injectMessage: C,
    removeMessage: h,
    streamMessage: P,
    endStreamMessage: D,
    replaceMessages: y,
    getMessages: b,
    messages: e
  };
};
let OA, uA, SA, BA = !1, cA = null;
const WA = () => {
  if (!OA) {
    const A = window.SpeechRecognition || window.webkitSpeechRecognition;
    OA = A != null ? new A() : null;
  }
  return OA;
}, Rt = (A, e, o, t, n, s, a) => {
  var r;
  (r = A.voice) != null && r.sendAsAudio ? Ut(o, s) : Ft(
    A,
    e,
    o,
    t,
    n,
    a
  );
}, Ft = (A, e, o, t, n, s) => {
  var i, u, f;
  const a = WA();
  if (!a)
    return;
  if (!BA)
    try {
      BA = !0, a.lang = (i = A.voice) == null ? void 0 : i.language, a.start();
    } catch {
    }
  const r = (u = A.voice) == null ? void 0 : u.timeoutPeriod, c = (f = A.voice) == null ? void 0 : f.autoSendPeriod;
  a.onresult = (w) => {
    var g, B;
    clearTimeout(uA), uA = null, clearTimeout(SA);
    const d = w.results[w.results.length - 1][0].transcript;
    if (s.current) {
      const v = (g = A.chatInput) == null ? void 0 : g.characterLimit, S = s.current.value + d;
      v != null && v >= 0 && S.length > v ? t(S.slice(0, v)) : t(S), n(s.current.value.length);
    }
    r && (uA = setTimeout(async () => await LA(e, s), r)), (B = A.voice) != null && B.autoSendDisabled || (SA = setTimeout(o, c));
  }, a.onend = () => {
    BA ? (a.start(), !uA && r && (uA = setTimeout(async () => await LA(e, s), r))) : (clearTimeout(uA), uA = null, clearTimeout(SA));
  }, r && (uA = setTimeout(async () => await LA(e, s), r));
}, Ut = (A, e) => {
  navigator.mediaDevices.getUserMedia({ audio: !0 }).then((o) => {
    if (cA = new MediaRecorder(o), !BA)
      try {
        BA = !0, cA.start();
      } catch {
      }
    cA.ondataavailable = (t) => {
      e.current && e.current.push(t.data);
    }, cA.onstop = () => {
      A(), o.getTracks().forEach((t) => t.stop());
    };
  }).catch((o) => {
    console.error("Unable to use microphone:", o);
  });
}, KA = () => {
  const A = WA();
  A && (BA = !1, A && A.stop(), cA && cA.state !== "inactive" && (cA.stop(), cA = null), clearTimeout(uA), uA = null, clearTimeout(SA));
}, jt = (A, e) => {
  var t, n, s;
  const o = WA();
  (t = e.voice) != null && t.disabled || !((n = e.chatInput) != null && n.blockSpam) || !o || (A && !BA ? (BA = !0, (s = e.voice) != null && s.sendAsAudio ? cA == null || cA.start() : o.start()) : A || KA());
}, LA = async (A, e) => {
  var o;
  (o = e.current) != null && o.disabled || await A(), KA();
}, MA = () => {
  const { settings: A } = N(), { voiceToggledOn: e, setSyncedVoiceToggledOn: o, syncedVoiceToggledOnRef: t } = AA(), { dispatchRcbEvent: n } = lA(), s = H(async (r) => {
    var c;
    r !== t.current && ((c = A.event) != null && c.rcbToggleVoice && (await n(
      x.TOGGLE_VOICE,
      {
        currState: t.current,
        newState: !t.current
      }
    )).defaultPrevented || o((i) => !i));
  }, [t]), a = H((r) => {
    jt(r, A);
  }, [A]);
  return {
    voiceToggledOn: e,
    toggleVoice: s,
    syncVoice: a
  };
}, DA = () => {
  var D;
  const { settings: A } = N(), {
    inputLength: e,
    setInputLength: o,
    textAreaDisabled: t,
    setSyncedTextAreaDisabled: n,
    textAreaSensitiveMode: s,
    setSyncedTextAreaSensitiveMode: a,
    syncedTextAreaDisabledRef: r,
    syncedTextAreaSensitiveModeRef: c
  } = AA(), { inputRef: i, chatBodyRef: u, prevInputRef: f } = _(), { dispatchRcbEvent: w } = lA(), { getIsChatBotVisible: d } = aA(), g = H(async (y) => {
    var b, T, O;
    if (r.current && i.current) {
      i.current.value = "";
      return;
    }
    if (i.current && f.current !== null) {
      const Q = (b = A.chatInput) == null ? void 0 : b.characterLimit, m = ((T = A.chatInput) == null ? void 0 : T.allowNewline) ? y : y.replace(/\n/g, " ");
      if (Q != null && Q >= 0 && m.length > Q ? i.current.value = m.slice(0, Q) : i.current.value = m, (O = A.event) != null && O.rcbTextAreaChangeValue && (await w(
        x.TEXT_AREA_CHANGE_VALUE,
        { currValue: i.current.value, prevValue: f.current }
      )).defaultPrevented) {
        i.current.value = f.current;
        return;
      }
      f.current = i.current.value;
    }
  }, [r, i, f, A, w]), B = H((y) => {
    var b;
    (b = i.current) != null && b.disabled || setTimeout(() => {
      var T, O, Q;
      (T = A.general) != null && T.embedded ? d() && ((O = i.current) == null || O.focus()) : y !== "start" && ((Q = i.current) == null || Q.focus());
    }, 100);
  }, [i, (D = A.general) == null ? void 0 : D.embedded, u, d]), v = H(() => {
    i.current && i.current.focus();
  }, []), S = H(() => {
    i.current && i.current.blur();
  }, []), C = H(() => i && i.current ? i.current.value : "", []), h = H((y) => {
    y !== r.current && n((b) => !b);
  }, [r]), P = H((y) => {
    y !== c.current && a((b) => !b);
  }, [c]);
  return {
    textAreaDisabled: t,
    setSyncedTextAreaDisabled: n,
    textAreaSensitiveMode: s,
    setSyncedTextAreaSensitiveMode: a,
    inputLength: e,
    setInputLength: o,
    getTextAreaValue: C,
    setTextAreaValue: g,
    updateTextAreaFocus: B,
    focusTextArea: v,
    blurTextArea: S,
    toggleTextAreaDisabled: h,
    toggleTextAreaSensitiveMode: P
  };
}, De = vA({
  toasts: [],
  setSyncedToasts: () => {
  },
  syncedToastsRef: { current: [] }
}), Ee = () => hA(De), zt = ({ children: A }) => {
  const [e, o, t] = rA([]);
  return /* @__PURE__ */ l(De.Provider, { value: { toasts: e, setSyncedToasts: o, syncedToastsRef: t }, children: A });
}, EA = () => {
  const { settings: A } = N(), { toasts: e, setSyncedToasts: o, syncedToastsRef: t } = Ee(), { dispatchRcbEvent: n } = lA(), s = H(async (c, i) => {
    var g, B, v, S;
    let u = null;
    if (t.current.length >= (((g = A.toast) == null ? void 0 : g.maxCount) ?? 3)) {
      if ((B = A.toast) != null && B.forbidOnMax)
        return null;
      u = IA();
      let C = { id: u, content: c, timeout: i };
      if ((v = A.event) != null && v.rcbShowToast) {
        const h = await n(x.SHOW_TOAST, { toast: C });
        if (h.defaultPrevented)
          return null;
        C = h.data.toast;
      }
      return o((h) => [...h.slice(1), C]), u;
    }
    u = IA();
    let d = { id: u, content: c, timeout: i };
    if ((S = A.event) != null && S.rcbShowToast) {
      const C = await n(x.SHOW_TOAST, { toast: d });
      if (C.defaultPrevented)
        return null;
      d = C.data.toast;
    }
    return o((C) => [...C, d]), u;
  }, [A, n]), a = H(async (c) => {
    var u;
    const i = t.current.find((f) => f.id === c);
    return !i || (u = A.event) != null && u.rcbDismissToast && (await n(x.DISMISS_TOAST, { toast: i })).defaultPrevented ? null : (o((f) => f.filter((w) => w.id !== c)), c);
  }, [n]), r = H((c) => {
    const i = typeof c == "function" ? c(t.current) : c;
    o(i);
  }, [t]);
  return {
    showToast: s,
    dismissToast: a,
    toasts: e,
    replaceToasts: r
  };
}, bA = () => {
  var I, L, Y, K, G;
  const { settings: A } = N(), { paths: e, setSyncedPaths: o, syncedPathsRef: t } = QA(), { flowRef: n, streamMessageMap: s, paramsInputRef: a, keepVoiceOnRef: r, timeoutIdRef: c } = _(), {
    setSyncedIsBotTyping: i,
    setSyncedTextAreaDisabled: u,
    setSyncedTextAreaSensitiveMode: f,
    blockAllowsAttachment: w,
    setBlockAllowsAttachment: d
  } = AA(), { dispatchRcbEvent: g } = lA(), {
    endStreamMessage: B,
    injectMessage: v,
    removeMessage: S,
    simulateStreamMessage: C,
    streamMessage: h
  } = PA(), { showToast: P, dismissToast: D } = EA(), { toggleChatWindow: y } = aA(), { updateTextAreaFocus: b, setTextAreaValue: T } = DA(), { syncVoice: O } = MA(), Q = H(async (R) => {
    var q;
    if ((q = A.event) != null && q.rcbPostProcessBlock) {
      const F = await g(x.POST_PROCESS_BLOCK, {
        block: R
      });
      if (F.defaultPrevented)
        return null;
      R = F.data.block;
    }
    return R;
  }, [(I = A.event) == null ? void 0 : I.rcbPostProcessBlock, g]), E = H(async (R, q) => {
    var U, eA, tA, nA;
    if (!R)
      return;
    let F = n.current[R];
    if (!F) {
      i(!1);
      return;
    }
    if ((U = A.event) != null && U.rcbPreProcessBlock) {
      const sA = await g(x.PRE_PROCESS_BLOCK, {
        block: F
      });
      if (sA.defaultPrevented)
        return;
      F = sA.data.block;
    }
    i(!0), (eA = A.chatInput) != null && eA.blockSpam && u(!0), f(!1);
    const j = {
      prevPath: q,
      currPath: R,
      goToPath: M,
      setTextAreaValue: T,
      userInput: a.current,
      endStreamMessage: B,
      injectMessage: v,
      removeMessage: S,
      simulateStreamMessage: C,
      streamMessage: h,
      toggleChatWindow: y,
      showToast: P,
      dismissToast: D
    };
    await Ct(
      F,
      j,
      ((tA = A.botBubble) == null ? void 0 : tA.simulateStream) ?? !1,
      c,
      u,
      f,
      Q
    ), i(!1), "chatDisabled" in F || u((nA = A.chatInput) == null ? void 0 : nA.disabled), "isSensitive" in F || f(!1), d(typeof F.file == "function"), b(R), O(r.current && !F.chatDisabled), R !== q && s.current.clear();
  }, [
    n,
    b,
    O,
    (L = A.botBubble) == null ? void 0 : L.simulateStream,
    (Y = A.chatInput) == null ? void 0 : Y.disabled,
    a,
    B,
    v,
    S,
    C,
    h,
    y,
    P,
    D,
    r,
    s
  ]), m = H(() => t.current.length > 0 ? t.current.at(-1) ?? null : null, []), p = H(() => t.current.length > 1 ? t.current.at(-2) ?? null : null, []), M = H(async (R) => {
    var j;
    const q = m(), F = p();
    return (j = A.event) != null && j.rcbChangePath && (await g(x.CHANGE_PATH, {
      currPath: q,
      prevPath: F,
      nextPath: R
    })).defaultPrevented ? !1 : (o((U) => [...U, R]), await E(R, q), !0);
  }, [(K = A.chatInput) == null ? void 0 : K.blockSpam, (G = A.event) == null ? void 0 : G.rcbChangePath, E, g]), k = H((R) => {
    const q = typeof R == "function" ? R(t.current) : R;
    o(q);
  }, [t]);
  return {
    getCurrPath: m,
    getPrevPath: p,
    goToPath: M,
    blockAllowsAttachment: w,
    setBlockAllowsAttachment: d,
    paths: e,
    replacePaths: k,
    firePostProcessBlockEvent: Q
  };
}, yA = () => {
  var I, L, Y, K;
  const { settings: A } = N(), {
    endStreamMessage: e,
    injectMessage: o,
    removeMessage: t,
    simulateStreamMessage: n,
    streamMessage: s
  } = PA(), { syncedPathsRef: a } = QA(), { getCurrPath: r, getPrevPath: c, goToPath: i, firePostProcessBlockEvent: u } = bA(), {
    setSyncedTextAreaSensitiveMode: f,
    setSyncedTextAreaDisabled: w,
    setSyncedIsBotTyping: d,
    setBlockAllowsAttachment: g,
    setInputLength: B,
    syncedVoiceToggledOnRef: v,
    syncedTextAreaSensitiveModeRef: S
  } = AA(), { flowRef: C, inputRef: h, keepVoiceOnRef: P, paramsInputRef: D, timeoutIdRef: y } = _(), { showToast: b, dismissToast: T } = EA(), { dispatchRcbEvent: O } = lA(), { syncVoice: Q } = MA(), { setTextAreaValue: E } = DA(), { toggleChatWindow: m } = aA(), p = H(async (G) => {
    var F, j, U, eA, tA, nA;
    const R = r();
    if (!(!R || !C.current[R])) {
      if (S.current) {
        if ((F = A == null ? void 0 : A.sensitiveInput) != null && F.hideInUserBubble)
          return;
        if ((j = A == null ? void 0 : A.sensitiveInput) != null && j.maskInUserBubble) {
          (U = A.userBubble) != null && U.simulateStream ? await n(
            "*".repeat(((eA = A.sensitiveInput) == null ? void 0 : eA.asterisksCount) ?? 10),
            "USER"
          ) : await o("*".repeat(((tA = A.sensitiveInput) == null ? void 0 : tA.asterisksCount) ?? 10), "USER");
          return;
        }
      }
      (nA = A.userBubble) != null && nA.simulateStream ? await n(G, "USER") : await o(G, "USER");
    }
  }, [C, r, A, o, n, S]), M = H(async (G, R = !0) => {
    var U, eA;
    if (G = G.trim(), G === "")
      return;
    R && await p(G), y.current && clearTimeout(y.current), h.current && (E(""), B(0));
    const q = r();
    if (!q)
      return;
    let F = C.current[q];
    const j = await u(F);
    j && ((U = A.chatInput) != null && U.blockSpam && w(!0), P.current = v.current, Q(!1), setTimeout(() => {
      d(!0);
    }, 400), f(!1), setTimeout(async () => {
      var sA;
      const tA = {
        prevPath: c(),
        currPath: r(),
        goToPath: i,
        setTextAreaValue: E,
        userInput: D.current,
        injectMessage: o,
        simulateStreamMessage: n,
        streamMessage: s,
        removeMessage: t,
        endStreamMessage: e,
        toggleChatWindow: m,
        showToast: b,
        dismissToast: T
      }, nA = a.current.length;
      await ge(j, tA), a.current.length === nA && ("chatDisabled" in F ? w(!!F.chatDisabled) : w(!!((sA = A.chatInput) != null && sA.disabled)), we(F, tA, f), g(typeof F.file == "function"), Q(P.current), d(!1));
    }, (eA = A.chatInput) == null ? void 0 : eA.botDelay));
  }, [
    y,
    (I = A.chatInput) == null ? void 0 : I.blockSpam,
    (L = A.chatInput) == null ? void 0 : L.botDelay,
    (Y = A.chatInput) == null ? void 0 : Y.disabled,
    P,
    v,
    Q,
    p,
    c,
    r,
    i,
    o,
    n,
    s,
    t,
    e,
    m,
    b,
    T,
    C
  ]);
  return { handleSubmitText: H(async (G, R = !0) => {
    var F, j;
    G = G ?? ((F = h.current) == null ? void 0 : F.value), !((j = A.event) != null && j.rcbUserSubmitText && (await O(x.USER_SUBMIT_TEXT, { inputText: G, sendInChat: R })).defaultPrevented || !r()) && M(G, R);
  }, [O, r, M, h, (K = A.event) == null ? void 0 : K.rcbUserSubmitText]) };
}, kA = () => {
  var o;
  const { settings: A } = N();
  return dA(() => {
    var a;
    if (typeof window > "u" || !window.navigator)
      return !1;
    if (!((a = A.device) != null && a.applyMobileOptimizations))
      return !0;
    const t = navigator.userAgent, n = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(t), s = window.innerWidth >= 768;
    return n && s;
  }, [(o = A.device) == null ? void 0 : o.applyMobileOptimizations]);
}, Gt = ({ buttons: A }) => {
  var p, M, k, I, L, Y, K, G, R, q, F;
  const e = kA(), { settings: o } = N(), { styles: t } = X(), {
    textAreaDisabled: n,
    textAreaSensitiveMode: s,
    inputLength: a,
    hasFlowStarted: r,
    setHasFlowStarted: c,
    setInputLength: i
  } = AA(), { inputRef: u } = _(), [f, w] = z(!1), [d, g] = z(!1), { handleSubmitText: B } = yA(), { setTextAreaValue: v } = DA(), S = {
    boxSizing: e ? "content-box" : "border-box",
    ...t.chatInputAreaStyle
  }, C = {
    outline: n ? "" : "none",
    boxShadow: n ? "" : `0 0 5px ${(p = o.general) == null ? void 0 : p.primaryColor}`,
    boxSizing: e ? "content-box" : "border-box",
    ...t.chatInputAreaStyle,
    // by default inherit the base style for input area
    ...t.chatInputAreaFocusedStyle
  }, h = {
    cursor: `url("${(M = o.general) == null ? void 0 : M.actionDisabledIcon}"), auto`,
    caretColor: "transparent",
    boxSizing: e ? "content-box" : "border-box",
    ...t.chatInputAreaStyle,
    // by default inherit the base style for input area
    ...t.chatInputAreaDisabledStyle
  }, P = {
    color: "#989898",
    ...t.characterLimitStyle
  }, D = {
    color: "#ff0000",
    ...t.characterLimitReachedStyle
  }, y = n ? (k = o.chatInput) == null ? void 0 : k.disabledPlaceholderText : (I = o.chatInput) == null ? void 0 : I.enabledPlaceholderText, b = () => {
    n || w(!0);
  }, T = () => {
    w(!1);
  }, O = () => {
    g(!0);
  }, Q = () => {
    g(!1);
  }, E = async (j) => {
    var U;
    if (!d && j.key === "Enter") {
      if (j.shiftKey) {
        (U = o.chatInput) != null && U.allowNewline || j.preventDefault();
        return;
      }
      j.preventDefault(), await B();
    }
  }, m = (j) => {
    u.current && (v(j.target.value), i(u.current.value.length));
  };
  return /* @__PURE__ */ W(
    "div",
    {
      "aria-label": ((L = o.ariaLabel) == null ? void 0 : L.inputTextArea) ?? "input text area",
      role: "textbox",
      onMouseDown: (j) => {
        var U;
        j.stopPropagation(), !r && ((U = o.general) == null ? void 0 : U.flowStartTrigger) === "ON_CHATBOT_INTERACT" && c(!0);
      },
      style: { ...t.chatInputContainerStyle },
      className: "rcb-chat-input",
      children: [
        s && ((Y = o.sensitiveInput) != null && Y.maskInTextArea) ? /* @__PURE__ */ l(
          "input",
          {
            ref: u,
            type: "password",
            className: "rcb-chat-input-textarea",
            style: n ? h : f ? C : S,
            placeholder: y,
            onChange: m,
            onKeyDown: E,
            onFocus: b,
            onBlur: T,
            onCompositionStart: O,
            onCompositionEnd: Q
          }
        ) : /* @__PURE__ */ l(
          "textarea",
          {
            ref: u,
            style: n ? h : f ? C : S,
            rows: 1,
            className: "rcb-chat-input-textarea",
            placeholder: y,
            onChange: m,
            onKeyDown: E,
            onFocus: b,
            onBlur: T,
            onCompositionStart: O,
            onCompositionEnd: Q
          }
        ),
        /* @__PURE__ */ W(oA, { children: [
          A == null ? void 0 : A.map(
            (j, U) => /* @__PURE__ */ l(jA, { children: j }, U)
          ),
          ((K = o.chatInput) == null ? void 0 : K.showCharacterCount) && ((G = o.chatInput) == null ? void 0 : G.characterLimit) != null && ((R = o.chatInput) == null ? void 0 : R.characterLimit) > 0 && /* @__PURE__ */ W(
            "div",
            {
              className: "rcb-chat-input-char-counter",
              style: a >= ((q = o.chatInput) == null ? void 0 : q.characterLimit) ? D : P,
              children: [
                a,
                "/",
                (F = o.chatInput) == null ? void 0 : F.characterLimit
              ]
            }
          )
        ] })
      ]
    }
  );
}, Yt = ({ buttons: A }) => {
  var t;
  const { settings: e } = N(), { styles: o } = X();
  return /* @__PURE__ */ W(
    "div",
    {
      "data-testid": "chatbot-footer-container",
      style: { ...o.footerStyle },
      className: "rcb-chat-footer-container",
      children: [
        /* @__PURE__ */ l("div", { className: "rcb-chat-footer", children: A == null ? void 0 : A.map(
          (n, s) => /* @__PURE__ */ l(jA, { children: n }, s)
        ) }),
        /* @__PURE__ */ l("span", { children: (t = e.footer) == null ? void 0 : t.text })
      ]
    }
  );
}, Xt = () => {
  var d, g, B, v, S, C, h;
  const { settings: A } = N(), { styles: e } = X(), { unreadCount: o } = AA(), { isChatWindowOpen: t, toggleChatWindow: n } = aA(), [s, a] = z(!1), r = {
    backgroundImage: `linear-gradient(to right, ${(d = A.general) == null ? void 0 : d.secondaryColor},
			${(g = A.general) == null ? void 0 : g.primaryColor})`,
    ...e.chatButtonStyle
  }, c = {
    transform: "scale(1.05)",
    ...r,
    // by default inherit the base style
    ...e.chatButtonHoveredStyle
  }, i = {
    backgroundImage: `url(${(B = A.chatButton) == null ? void 0 : B.icon})`,
    fill: "#fff",
    width: 75,
    height: 75,
    ...e.chatIconStyle
  }, u = () => {
    a(!0);
  }, f = () => {
    a(!1);
  }, w = () => {
    var D;
    const P = (D = A.chatButton) == null ? void 0 : D.icon;
    return !P || typeof P == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: "rcb-toggle-icon",
        style: i
      }
    ) : P && /* @__PURE__ */ l("span", { className: "rcb-toggle-icon", children: /* @__PURE__ */ l(P, { style: i }) });
  };
  return /* @__PURE__ */ l(oA, { children: !((v = A.general) != null && v.embedded) && /* @__PURE__ */ W(
    "div",
    {
      "aria-label": ((S = A.ariaLabel) == null ? void 0 : S.chatButton) ?? "open chat",
      role: "button",
      style: s ? c : r,
      className: `rcb-toggle-button ${t ? "rcb-button-hide" : "rcb-button-show"}`,
      onMouseEnter: u,
      onMouseLeave: f,
      onClick: () => n(!0),
      children: [
        w(),
        !((C = A.notification) != null && C.disabled) && ((h = A.notification) == null ? void 0 : h.showCount) && /* @__PURE__ */ l("span", { style: { ...e.notificationBadgeStyle }, className: "rcb-badge", children: o })
      ]
    }
  ) });
}, Wt = () => {
  var g, B, v, S, C, h;
  const A = kA(), { settings: e } = N(), { styles: o } = X(), { chatBodyRef: t } = _(), { isChatWindowOpen: n, toggleChatWindow: s } = aA(), [a, r] = z(!1), [c, i] = z(!1), [u, f] = z(0);
  J(() => {
    var D, y, b;
    const P = (D = e.tooltip) == null ? void 0 : D.mode;
    if (P === "ALWAYS")
      if (A) {
        let T;
        n ? T = (((y = t.current) == null ? void 0 : y.offsetWidth) ?? 375) - (typeof ((b = o.chatButtonStyle) == null ? void 0 : b.width) == "number" ? o.chatButtonStyle.width : 75) : T = 0, f(T), r(!0);
      } else
        r(!n);
    else P === "NEVER" ? r(!1) : P === "START" ? c ? r(!1) : (i(!0), r(!0)) : P === "CLOSE" && r(!n);
  }, [
    n,
    A,
    c,
    (g = o.chatButtonStyle) == null ? void 0 : g.width,
    (B = e.tooltip) == null ? void 0 : B.mode
  ]);
  const w = {
    transform: `translateX(-${u}px)`,
    right: (((v = o.chatButtonStyle) == null ? void 0 : v.width) ?? 75) + 40,
    bottom: 30,
    backgroundColor: (S = e.general) == null ? void 0 : S.secondaryColor,
    color: "#fff",
    ...o.tooltipStyle
  }, d = {
    borderColor: `transparent transparent transparent ${w.backgroundColor}`
  };
  return /* @__PURE__ */ l(oA, { children: !((C = e.general) != null && C.embedded) && /* @__PURE__ */ W(
    "div",
    {
      "data-testid": "chat-tooltip",
      style: w,
      className: `rcb-chat-tooltip ${a ? "rcb-tooltip-show" : "rcb-tooltip-hide"}`,
      onClick: () => s(!0),
      children: [
        /* @__PURE__ */ l("span", { children: (h = e.tooltip) == null ? void 0 : h.text }),
        /* @__PURE__ */ l("span", { className: "rcb-chat-tooltip-tail", style: d })
      ]
    }
  ) });
}, Kt = ({
  id: A,
  content: e,
  timeout: o
}) => {
  var w, d;
  const { settings: t } = N(), { styles: n } = X(), [s] = z({
    toastPromptStyle: { ...n.toastPromptStyle },
    toastPromptHoveredStyle: { ...n.toastPromptHoveredStyle }
  }), { dismissToast: a } = EA(), [r, c] = z(!1), i = {
    color: (w = t.general) == null ? void 0 : w.primaryColor,
    borderColor: (d = t.general) == null ? void 0 : d.primaryColor,
    ...s.toastPromptHoveredStyle
  };
  return J(() => {
    if (o) {
      const g = setTimeout(() => {
        a(A);
      }, o);
      return () => clearTimeout(g);
    }
  }, [A, a, o]), typeof e == "string" ? /* @__PURE__ */ l(
    "div",
    {
      onMouseEnter: () => {
        c(!0);
      },
      onMouseLeave: () => {
        c(!1);
      },
      style: r ? i : s.toastPromptStyle,
      onMouseDown: async (g) => {
        var B;
        (B = t.toast) != null && B.dismissOnClick && (g.preventDefault(), await a(A));
      },
      className: "rcb-toast-prompt",
      children: e
    }
  ) : /* @__PURE__ */ l(oA, { children: e });
}, qt = () => {
  var t, n, s, a, r, c, i, u, f, w, d, g;
  const { styles: A } = X(), { toasts: e } = Ee(), o = {
    bottom: `calc(${typeof ((t = A.footerStyle) == null ? void 0 : t.height) == "number" ? `${(n = A.footerStyle) == null ? void 0 : n.height}px` : ((s = A.footerStyle) == null ? void 0 : s.height) ?? "50px"} + ${typeof ((a = A.chatInputContainerStyle) == null ? void 0 : a.height) == "number" ? `${(r = A.chatInputContainerStyle) == null ? void 0 : r.height}px` : ((c = A.chatInputContainerStyle) == null ? void 0 : c.height) ?? "70px"} + 20px)`,
    width: 300,
    minWidth: `calc(${typeof ((i = A.chatWindowStyle) == null ? void 0 : i.width) == "number" ? `${(u = A.chatWindowStyle) == null ? void 0 : u.width}px` : ((f = A.chatWindowStyle) == null ? void 0 : f.width) ?? "375px"} / 2)`,
    maxWidth: `calc(${typeof ((w = A.chatWindowStyle) == null ? void 0 : w.width) == "number" ? `${(d = A.chatWindowStyle) == null ? void 0 : d.width}px` : ((g = A.chatWindowStyle) == null ? void 0 : g.width) ?? "375px"} - 50px)`,
    ...A.toastPromptContainerStyle
  };
  return /* @__PURE__ */ l("div", { className: "rcb-toast-prompt-container", style: o, children: e.map((B) => /* @__PURE__ */ l(
    Kt,
    {
      id: B.id,
      content: B.content,
      timeout: B.timeout
    },
    B.id
  )) });
}, ye = ({
  file: A,
  fileType: e,
  fileUrl: o
}) => {
  var a, r, c;
  const { settings: t } = N(), { styles: n } = X(), s = {
    backgroundColor: (a = t.general) == null ? void 0 : a.primaryColor,
    maxWidth: (r = t.userBubble) != null && r.showAvatar ? "65%" : "70%",
    ...n.mediaDisplayContainerStyle
  };
  return /* @__PURE__ */ l(oA, { children: o ? /* @__PURE__ */ W(oA, { children: [
    e === "image" && o && /* @__PURE__ */ l(
      "div",
      {
        style: s,
        className: "rcb-media-display-image-container rcb-media-entry",
        "data-testid": "media-display-image-container",
        children: /* @__PURE__ */ l("img", { src: o, alt: "Image Display", className: "rcb-media-display-image" })
      }
    ),
    e === "video" && o && /* @__PURE__ */ l(
      "div",
      {
        style: s,
        className: "rcb-media-display-video-container rcb-media-entry",
        "data-testid": "media-display-video-container",
        children: /* @__PURE__ */ W("video", { controls: !0, className: "rcb-media-display-video", children: [
          /* @__PURE__ */ l("source", { src: o, type: A.type }),
          "Your browser does not support the video tag."
        ] })
      }
    ),
    e === "audio" && o && /* @__PURE__ */ W(
      "audio",
      {
        "data-testid": "media-display-audio-container",
        style: {
          maxWidth: (c = t.userBubble) != null && c.showAvatar ? "65%" : "70%"
        },
        controls: !0,
        className: "rcb-media-display-audio rcb-media-entry",
        children: [
          /* @__PURE__ */ l("source", { src: o, type: A.type }),
          "Your browser does not support the audio tag."
        ]
      }
    )
  ] }) : /* @__PURE__ */ l(oA, {}) });
}, Ce = async (A) => {
  if (!A)
    return { fileType: null, fileUrl: null };
  const e = A.type.split("/")[0];
  if (!["image", "video", "audio"].includes(e))
    return { fileType: null, fileUrl: null };
  try {
    const o = await new Promise((t, n) => {
      const s = new FileReader();
      s.onload = () => t(s.result), s.onerror = () => n(new Error("File reading failed")), s.readAsDataURL(A);
    });
    return { fileType: e, fileUrl: o };
  } catch (o) {
    return console.error(o), { fileType: null, fileUrl: null };
  }
}, Jt = () => {
  var O, Q, E, m, p, M;
  const { settings: A } = N(), { styles: e } = X(), {
    injectMessage: o,
    simulateStreamMessage: t,
    streamMessage: n,
    removeMessage: s,
    endStreamMessage: a
  } = PA(), { getCurrPath: r, getPrevPath: c, goToPath: i, blockAllowsAttachment: u } = bA(), { flowRef: f, inputRef: w } = _(), d = f.current, { showToast: g, dismissToast: B } = EA(), { dispatchRcbEvent: v } = lA(), { toggleChatWindow: S } = aA(), { setTextAreaValue: C } = DA(), { handleSubmitText: h } = yA(), P = {
    cursor: `url("${(O = A.general) == null ? void 0 : O.actionDisabledIcon}"), auto`,
    ...e.fileAttachmentButtonStyle,
    // by default inherit the base style
    ...e.fileAttachmentButtonDisabledStyle
  }, D = {
    backgroundImage: `url(${(Q = A.fileAttachment) == null ? void 0 : Q.icon})`,
    fill: "#a6a6a6",
    ...e.fileAttachmentIconStyle
  }, y = {
    backgroundImage: `url(${(E = A.fileAttachment) == null ? void 0 : E.icon})`,
    fill: "#a6a6a6",
    ...e.fileAttachmentIconStyle,
    // by default inherit the base style
    ...e.fileAttachmentIconDisabledStyle
  }, b = async (k) => {
    var R, q, F, j;
    const I = k.target.files;
    if (!I)
      return;
    const L = Array.from(I);
    if (k.target.value = "", (R = A.event) != null && R.rcbUserUploadFile && (await v(x.USER_UPLOAD_FILE, { files: L })).defaultPrevented)
      return;
    const Y = r();
    if (!Y)
      return;
    const K = d[Y];
    if (!K)
      return;
    const G = K.file;
    if (G != null) {
      const U = [];
      for (let eA = 0; eA < L.length; eA++) {
        if (U.push(L[eA].name), !((q = A.fileAttachment) != null && q.showMediaDisplay))
          continue;
        const tA = await Ce(L[eA]);
        !tA.fileType || !tA.fileUrl || await o(/* @__PURE__ */ l(
          ye,
          {
            file: L[eA],
            fileType: tA.fileType,
            fileUrl: tA.fileUrl
          }
        ), "USER");
      }
      await h("📄 " + U.join(", "), (F = A.fileAttachment) == null ? void 0 : F.sendFileName), await G({
        userInput: (j = w.current) == null ? void 0 : j.value,
        prevPath: c(),
        currPath: r(),
        goToPath: i,
        setTextAreaValue: C,
        injectMessage: o,
        simulateStreamMessage: t,
        streamMessage: n,
        removeMessage: s,
        endStreamMessage: a,
        toggleChatWindow: S,
        showToast: g,
        dismissToast: B,
        files: L
      });
    }
  }, T = () => {
    var I, L;
    const k = u ? (I = A.fileAttachment) == null ? void 0 : I.icon : (L = A.fileAttachment) == null ? void 0 : L.iconDisabled;
    return !k || typeof k == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: u ? "rcb-attach-icon-enabled" : "rcb-attach-icon-disabled",
        style: u ? D : y
      }
    ) : k && /* @__PURE__ */ l("span", { className: u ? "rcb-attach-icon-enabled" : "rcb-attach-icon-disabled", children: /* @__PURE__ */ l(
      k,
      {
        style: u ? D : y
      }
    ) });
  };
  return /* @__PURE__ */ W(
    "label",
    {
      "aria-label": ((m = A.ariaLabel) == null ? void 0 : m.fileAttachmentButton) ?? "upload file",
      role: "button",
      className: u ? "rcb-attach-button-enabled" : "rcb-attach-button-disabled",
      style: u ? { ...e.fileAttachmentButtonStyle } : P,
      children: [
        /* @__PURE__ */ l(
          "input",
          {
            className: "rcb-attach-input",
            role: "file",
            type: "file",
            onChange: b,
            multiple: (p = A.fileAttachment) == null ? void 0 : p.multiple,
            accept: (M = A.fileAttachment) == null ? void 0 : M.accept,
            disabled: !u
          }
        ),
        T()
      ]
    }
  );
}, Vt = () => {
  var v, S, C, h, P, D;
  const { settings: A } = N(), { styles: e } = X(), { syncedTextAreaDisabledRef: o } = AA(), { inputRef: t } = _(), { textAreaDisabled: n, setTextAreaValue: s } = DA(), a = $(null), r = $(null), [c, i] = z(!1), u = {
    cursor: `url("${(v = A.general) == null ? void 0 : v.actionDisabledIcon}"), auto`,
    ...e.emojiButtonStyle,
    // by default inherit the base style
    ...e.emojiButtonDisabledStyle
  }, f = {
    backgroundImage: `url(${(S = A.emoji) == null ? void 0 : S.icon})`,
    fill: "#a6a6a6",
    ...e.emojiIconStyle
  }, w = {
    backgroundImage: `url(${(C = A.emoji) == null ? void 0 : C.icon})`,
    fill: "#a6a6a6",
    ...e.emojiIconStyle,
    // by default inherit the base style
    ...e.emojiIconDisabledStyle
  };
  J(() => {
    const y = (O) => {
      const Q = O.composedPath();
      a.current && !Q.includes(a.current) && r.current && !Q.includes(r.current) && i(!1);
    }, b = () => {
      if (a.current && r.current) {
        const O = r.current.getBoundingClientRect(), Q = a.current.offsetHeight, E = O.top - Q - 8;
        a.current.style.left = `${O.left}px`, a.current.style.top = `${E}px`;
      }
    }, T = () => {
      b();
    };
    return document.addEventListener("mousedown", y), window.addEventListener("resize", T), () => {
      document.removeEventListener("mousedown", y), window.removeEventListener("resize", T);
    };
  }, []);
  const d = (y, b) => {
    y.preventDefault(), t.current && (s(t.current.value + b), setTimeout(() => {
      const T = t.current;
      if (T) {
        T.focus();
        const O = T.value.length;
        T.setSelectionRange(O, O);
      }
    }, 50)), i(!1);
  }, g = (y) => {
    y.preventDefault(), o.current ? i(!1) : i((b) => !b);
  }, B = () => {
    var b, T;
    const y = n ? (b = A.emoji) == null ? void 0 : b.iconDisabled : (T = A.emoji) == null ? void 0 : T.icon;
    return !y || typeof y == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: `${n ? "rcb-emoji-icon-disabled" : "rcb-emoji-icon-enabled"}`,
        style: n ? w : f
      }
    ) : y && /* @__PURE__ */ l("span", { className: `${n ? "rcb-emoji-icon-disabled" : "rcb-emoji-icon-enabled"}`, children: /* @__PURE__ */ l(y, { style: n ? w : f }) });
  };
  return /* @__PURE__ */ W(oA, { children: [
    /* @__PURE__ */ l(
      "div",
      {
        "aria-label": ((h = A.ariaLabel) == null ? void 0 : h.emojiButton) ?? "emoji picker",
        role: "button",
        ref: r,
        className: `${n ? "rcb-emoji-button-disabled" : "rcb-emoji-button-enabled"}`,
        style: n ? u : { ...e.emojiButtonStyle },
        onMouseDown: g,
        children: B()
      }
    ),
    c && /* @__PURE__ */ l("div", { className: "rcb-emoji-button-popup", ref: a, children: (D = (P = A.emoji) == null ? void 0 : P.list) == null ? void 0 : D.map((y, b) => /* @__PURE__ */ l(
      "span",
      {
        className: "rcb-emoji",
        onMouseDown: (T) => d(T, y),
        children: y
      },
      b
    )) })
  ] });
}, Zt = () => {
  var r, c, i;
  const { settings: A } = N(), { styles: e } = X(), { audioToggledOn: o, toggleAudio: t } = XA(), n = {
    backgroundImage: `url(${(r = A.audio) == null ? void 0 : r.icon})`,
    fill: "#fcec3d",
    ...e.audioIconStyle
  }, s = {
    backgroundImage: `url(${(c = A.audio) == null ? void 0 : c.iconDisabled})`,
    fill: "#e8eaed",
    ...e.audioIconStyle,
    // by default inherit the base style
    ...e.audioIconDisabledStyle
  }, a = () => {
    var f, w;
    const u = o ? (f = A.audio) == null ? void 0 : f.icon : (w = A.audio) == null ? void 0 : w.iconDisabled;
    return !u || typeof u == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: "rcb-audio-icon",
        "data-testid": "rcb-audio-icon",
        style: o ? n : s
      }
    ) : u && /* @__PURE__ */ l("span", { className: "rcb-audio-icon", "data-testid": "rcb-audio-icon", children: /* @__PURE__ */ l(
      u,
      {
        style: o ? n : s,
        "data-testid": "rcb-audio-icon-svg"
      }
    ) });
  };
  return /* @__PURE__ */ l(
    "div",
    {
      "aria-label": ((i = A.ariaLabel) == null ? void 0 : i.audioButton) ?? "toggle audio",
      role: "button",
      onMouseDown: async (u) => {
        u.preventDefault(), await t();
      },
      style: o ? { ...e.audioButtonStyle } : { ...e.audioButtonStyle, ...e.audioButtonDisabledStyle },
      children: a()
    }
  );
}, _t = () => {
  var s, a;
  const { settings: A } = N(), { styles: e } = X(), { toggleChatWindow: o } = aA(), t = {
    backgroundImage: `url(${(s = A.header) == null ? void 0 : s.closeChatIcon})`,
    fill: "#e8eaed",
    stroke: "#e8eaed",
    ...e.closeChatIconStyle
  }, n = () => {
    var c;
    const r = (c = A.header) == null ? void 0 : c.closeChatIcon;
    return !r || typeof r == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: "rcb-close-chat-icon",
        "data-testid": "rcb-close-chat-icon",
        style: t
      }
    ) : r && /* @__PURE__ */ l("span", { className: "rcb-close-chat-icon", "data-testid": "rcb-close-chat-icon", children: /* @__PURE__ */ l(r, { style: t }) });
  };
  return /* @__PURE__ */ l(
    "div",
    {
      "aria-label": ((a = A.ariaLabel) == null ? void 0 : a.closeChatButton) ?? "close chat",
      role: "button",
      onMouseDown: (r) => {
        r.stopPropagation(), o(!1);
      },
      style: { ...e.closeChatButtonStyle },
      children: n()
    }
  );
}, $t = () => {
  const { notificationsToggledOn: A, toggleNotifications: e, playNotificationSound: o } = YA();
  return {
    notificationsToggledOn: A,
    toggleNotifications: e,
    playNotificationSound: o
  };
}, Ao = () => {
  var r, c, i;
  const { settings: A } = N(), { styles: e } = X(), { notificationsToggledOn: o, toggleNotifications: t } = $t(), n = {
    backgroundImage: `url(${(r = A.notification) == null ? void 0 : r.icon})`,
    fill: "#fcec3d",
    ...e.notificationIconStyle
  }, s = {
    backgroundImage: `url(${(c = A.notification) == null ? void 0 : c.iconDisabled})`,
    fill: "#e8eaed",
    ...e.notificationIconStyle,
    // by default inherit the base style
    ...e.notificationIconDisabledStyle
  }, a = () => {
    var f, w;
    const u = o ? (f = A.notification) == null ? void 0 : f.icon : (w = A.notification) == null ? void 0 : w.iconDisabled;
    return !u || typeof u == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: "rcb-notification-icon",
        "data-testid": "rcb-notification-icon",
        style: o ? n : s
      }
    ) : u && /* @__PURE__ */ l("span", { className: "rcb-notification-icon", "data-testid": "rcb-notification-icon", children: /* @__PURE__ */ l(
      u,
      {
        style: o ? n : s,
        "data-testid": "rcb-notification-icon-svg"
      }
    ) });
  };
  return /* @__PURE__ */ l(
    "div",
    {
      "aria-label": ((i = A.ariaLabel) == null ? void 0 : i.notificationButton) ?? "toggle notifications",
      role: "button",
      onMouseDown: async (u) => {
        u.preventDefault(), await t();
      },
      style: o ? { ...e.notificationButtonStyle } : { ...e.notificationButtonStyle, ...e.notificationButtonDisabledStyle },
      children: a()
    }
  );
}, eo = () => {
  var C, h, P;
  const { settings: A } = N(), { styles: e } = X(), { injectMessage: o } = PA(), { inputRef: t } = _(), { voiceToggledOn: n, toggleVoice: s } = MA(), { setInputLength: a, setTextAreaValue: r, textAreaDisabled: c } = DA(), { handleSubmitText: i } = yA(), u = $([]), [f, w] = z(!1);
  J(() => {
    var D;
    (D = A.voice) != null && D.sendAsAudio ? (v(), u.current = []) : i();
  }, [f]), J(() => {
    n ? Rt(
      A,
      s,
      B,
      r,
      a,
      u,
      t
    ) : KA();
  }, [n]);
  const d = {
    backgroundImage: `url(${(C = A.voice) == null ? void 0 : C.icon})`,
    fill: "#9aa0a6",
    ...e.voiceIconStyle
  }, g = {
    backgroundImage: `url(${(h = A.voice) == null ? void 0 : h.iconDisabled})`,
    fill: "#9aa0a6",
    ...e.voiceIconStyle,
    // by default inherit the base style
    ...e.voiceIconDisabledStyle
  }, B = () => {
    w((D) => !D);
  }, v = async () => {
    const D = new Blob(u.current, { type: "audio/wav" }), y = new File([D], "voice-input.wav", { type: "audio/wav" }), b = await Ce(y);
    !b.fileType || !b.fileUrl || await o(/* @__PURE__ */ l(
      ye,
      {
        file: y,
        fileType: b.fileType,
        fileUrl: b.fileUrl
      }
    ), "USER");
  }, S = () => {
    var y, b;
    const D = n ? (y = A.voice) == null ? void 0 : y.icon : (b = A.voice) == null ? void 0 : b.iconDisabled;
    return !D || typeof D == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: `rcb-voice-icon${n && !c ? "-on" : ""}`,
        "data-testid": "rcb-voice-icon",
        style: n && !c ? d : g
      }
    ) : D && /* @__PURE__ */ l("span", { className: `rcb-voice-icon ${n && !c ? "on" : ""}`, children: /* @__PURE__ */ l(D, { style: n && !c ? d : g }) });
  };
  return /* @__PURE__ */ l(
    "div",
    {
      "aria-label": ((P = A.ariaLabel) == null ? void 0 : P.voiceButton) ?? "toggle voice",
      role: "button",
      onMouseDown: async (D) => {
        D.preventDefault(), !c && await s();
      },
      style: n && !c ? { ...e.voiceButtonStyle } : { ...e.voiceButtonStyle, ...e.voiceButtonDisabledStyle },
      className: n && !c ? "rcb-voice-button-enabled" : "rcb-voice-button-disabled",
      children: S()
    }
  );
}, to = () => {
  var B, v, S, C, h, P, D, y;
  const { settings: A } = N(), { styles: e } = X(), { textAreaDisabled: o } = AA(), [t, n] = z(!1), { handleSubmitText: s } = yA(), a = {
    backgroundColor: (B = A.general) == null ? void 0 : B.primaryColor,
    ...e.sendButtonStyle
  }, r = {
    cursor: `url("${(v = A.general) == null ? void 0 : v.actionDisabledIcon}"), auto`,
    backgroundColor: (S = A.general) == null ? void 0 : S.primaryColor,
    ...e.sendButtonStyle,
    // by default inherit the base style
    ...e.sendButtonDisabledStyle
  }, c = {
    backgroundColor: (C = A.general) == null ? void 0 : C.secondaryColor,
    ...e.sendButtonStyle,
    // by default inherit the base style
    ...e.sendButtonHoveredStyle
  }, i = {
    backgroundImage: `url(${(h = A.chatInput) == null ? void 0 : h.sendButtonIcon})`,
    fill: "#fff",
    ...e.sendIconStyle
  }, u = {
    backgroundImage: `url(${(P = A.chatInput) == null ? void 0 : P.sendButtonIcon})`,
    fill: "#fff",
    ...e.sendIconStyle,
    // by default inherit the base style
    ...e.sendIconDisabledStyle
  }, f = {
    backgroundImage: `url(${(D = A.chatInput) == null ? void 0 : D.sendButtonIcon})`,
    fill: "#fff",
    ...e.sendIconStyle,
    // by default inherit the base style
    ...e.sendIconHoveredStyle
  }, w = () => {
    n(!0);
  }, d = () => {
    n(!1);
  }, g = () => {
    var T;
    const b = (T = A.chatInput) == null ? void 0 : T.sendButtonIcon;
    return !b || typeof b == "string" ? /* @__PURE__ */ l(
      "span",
      {
        className: "rcb-send-icon",
        "data-testid": "rcb-send-icon",
        style: o ? u : t ? f : i
      }
    ) : b && /* @__PURE__ */ l("span", { className: "rcb-send-icon", "data-testid": "rcb-send-icon", children: /* @__PURE__ */ l(
      b,
      {
        style: o ? u : t ? f : i
      }
    ) });
  };
  return /* @__PURE__ */ l(
    "div",
    {
      "aria-label": ((y = A.ariaLabel) == null ? void 0 : y.sendButton) ?? "send message",
      role: "button",
      onMouseEnter: w,
      onMouseLeave: d,
      onMouseDown: async (b) => {
        b == null || b.preventDefault(), !o && await s();
      },
      style: o ? r : t ? c : a,
      className: "rcb-send-button",
      children: g()
    }
  );
}, oo = (A) => Object.values(Z).includes(A), no = (A, e) => {
  var c, i, u, f, w, d, g, B, v;
  const o = {
    [Z.AUDIO_BUTTON]: (c = A.audio) == null ? void 0 : c.disabled,
    [Z.CLOSE_CHAT_BUTTON]: (i = A.general) == null ? void 0 : i.embedded,
    [Z.EMOJI_PICKER_BUTTON]: (u = A.emoji) == null ? void 0 : u.disabled,
    [Z.FILE_ATTACHMENT_BUTTON]: (f = A.fileAttachment) == null ? void 0 : f.disabled,
    [Z.NOTIFICATION_BUTTON]: (w = A.notification) == null ? void 0 : w.disabled,
    [Z.SEND_MESSAGE_BUTTON]: !1,
    [Z.VOICE_MESSAGE_BUTTON]: (d = A.voice) == null ? void 0 : d.disabled
  }, t = {}, n = (S) => S ? S.map((C) => {
    if (typeof C == "string") {
      if (oo(C) && !o[C]) {
        if (t[C])
          return t[C];
        const h = e[C];
        if (typeof h == "function") {
          const P = h();
          return t[C] = P, P;
        }
        return null;
      }
      return null;
    }
    return C;
  }).filter((C) => C !== null) : [], s = n((g = A.header) == null ? void 0 : g.buttons), a = n((B = A.chatInput) == null ? void 0 : B.buttons), r = n((v = A.footer) == null ? void 0 : v.buttons);
  return { header: s, chatInput: a, footer: r };
}, so = () => /* @__PURE__ */ l(Zt, {}), ro = () => /* @__PURE__ */ l(Ao, {}), ao = () => /* @__PURE__ */ l(_t, {}), co = () => /* @__PURE__ */ l(eo, {}), io = () => /* @__PURE__ */ l(to, {}), lo = () => /* @__PURE__ */ l(Jt, {}), uo = () => /* @__PURE__ */ l(Vt, {}), fo = () => {
  const { settings: A } = N(), e = dA(() => ({
    [Z.CLOSE_CHAT_BUTTON]: () => ao(),
    [Z.AUDIO_BUTTON]: () => so(),
    [Z.NOTIFICATION_BUTTON]: () => ro(),
    [Z.EMOJI_PICKER_BUTTON]: () => uo(),
    [Z.FILE_ATTACHMENT_BUTTON]: () => lo(),
    [Z.SEND_MESSAGE_BUTTON]: () => io(),
    [Z.VOICE_MESSAGE_BUTTON]: () => co()
  }), []), { header: o, chatInput: t, footer: n } = dA(() => no(A, e), [A, e]), s = dA(() => o, [o]), a = dA(() => t, [t]), r = dA(() => n, [n]);
  return { headerButtons: s, chatInputButtons: a, footerButtons: r };
}, qA = () => {
  const { settings: A } = N(), { styles: e } = X(), { setSyncedMessages: o, syncedMessagesRef: t } = zA(), {
    isLoadingChatHistory: n,
    setIsLoadingChatHistory: s,
    hasChatHistoryLoaded: a,
    setHasChatHistoryLoaded: r
  } = AA(), { chatBodyRef: c } = _(), { dispatchRcbEvent: i } = lA(), u = H(async () => {
    var d, g;
    const f = GA();
    if (!f || (d = A.event) != null && d.rcbLoadChatHistory && (await i(x.LOAD_CHAT_HISTORY, {})).defaultPrevented)
      return;
    s(!0);
    const w = ((g = c.current) == null ? void 0 : g.scrollHeight) ?? 0;
    Tt(
      A,
      e,
      f,
      o,
      t,
      c,
      w,
      s,
      r
    );
  }, [
    A,
    e,
    i,
    t,
    c,
    s,
    r
  ]);
  return { isLoadingChatHistory: n, setIsLoadingChatHistory: s, hasChatHistoryLoaded: a, showChatHistory: u };
}, wo = () => {
  var c, i, u;
  const { settings: A } = N(), { styles: e } = X(), { showChatHistory: o } = qA(), [t, n] = z(!1), s = {
    color: (c = A.general) == null ? void 0 : c.primaryColor,
    borderColor: (i = A.general) == null ? void 0 : i.primaryColor,
    ...e.chatHistoryButtonStyle,
    // by default inherit the base style
    ...e.chatHistoryButtonHoveredStyle
  };
  return /* @__PURE__ */ l("div", { className: "rcb-view-history-container", children: /* @__PURE__ */ l(
    "div",
    {
      onMouseEnter: () => {
        n(!0);
      },
      onMouseLeave: () => {
        n(!1);
      },
      style: t ? s : { ...e.chatHistoryButtonStyle },
      onMouseDown: (f) => {
        f.preventDefault(), o();
      },
      className: "rcb-view-history-button",
      role: "button",
      tabIndex: 0,
      children: /* @__PURE__ */ l("p", { children: (u = A.chatHistory) == null ? void 0 : u.viewChatHistoryButtonText })
    }
  ) });
}, me = () => {
  var a;
  const { settings: A } = N(), { hasInteractedPage: e, setHasInteractedPage: o, hasFlowStarted: t, setHasFlowStarted: n } = AA(), s = H(() => {
    var c;
    if (o(!0), !t && ((c = A.general) == null ? void 0 : c.flowStartTrigger) === "ON_PAGE_INTERACT" && n(!0), !window.SpeechSynthesisUtterance) {
      console.info("Speech Synthesis API is not supported in this environment.");
      return;
    }
    const r = new window.SpeechSynthesisUtterance();
    r.text = "", r.onend = () => {
      window.removeEventListener("click", s), window.removeEventListener("keydown", s), window.removeEventListener("touchstart", s);
    }, window.speechSynthesis.speak(r);
  }, [t, (a = A.general) == null ? void 0 : a.flowStartTrigger]);
  return {
    hasInteractedPage: e,
    handleFirstInteraction: s
  };
}, go = () => {
  var b, T, O, Q;
  const A = kA(), { settings: e } = N(), {
    replaceMessages: o
  } = PA(), {
    isBotTyping: t,
    isChatWindowOpen: n,
    setUnreadCount: s,
    setSyncedIsChatWindowOpen: a,
    setSyncedTextAreaDisabled: r,
    setSyncedAudioToggledOn: c,
    setSyncedVoiceToggledOn: i,
    setSyncedIsScrolling: u,
    syncedIsScrollingRef: f,
    syncedIsChatWindowOpenRef: w
  } = AA(), { chatBodyRef: d } = _(), { viewportHeight: g, setViewportHeight: B, setViewportWidth: v, scrollToBottom: S } = aA(), { setUpNotifications: C } = YA(), { handleFirstInteraction: h } = me(), { showChatHistory: P } = qA(), D = $(0), y = $(!1);
  J(() => (window.addEventListener("click", h), window.addEventListener("keydown", h), window.addEventListener("touchstart", h), () => {
    window.removeEventListener("click", h), window.removeEventListener("keydown", h), window.removeEventListener("touchstart", h);
  }), []), J(() => {
    const E = d.current;
    if (!E)
      return;
    const m = () => {
      y.current || (y.current = !0, requestAnimationFrame(() => {
        var L, Y;
        if (!E)
          return;
        const { scrollTop: p, clientHeight: M, scrollHeight: k } = E, I = p + M < k - (((L = e.chatWindow) == null ? void 0 : L.messagePromptOffset) ?? 30);
        u(I), f.current = I, I || (p + M >= k - 1 && (E.scrollTop = k - M - 1), (w.current || (Y = e.general) != null && Y.embedded) && s(0)), y.current = !1;
      }));
    };
    return E.addEventListener("wheel", m, { passive: !0 }), E.addEventListener("touchmove", m, { passive: !0 }), () => {
      E.removeEventListener("wheel", m), E.removeEventListener("touchmove", m);
    };
  }, []), J(() => {
    var p, M, k;
    r((p = e.chatInput) == null ? void 0 : p.disabled);
    const E = (M = e.chatWindow) == null ? void 0 : M.defaultOpen, m = localStorage.getItem("React-chatbotify-is-chat-window-open") === "true";
    a(E || m), c((k = e.audio) == null ? void 0 : k.defaultToggledOn), setTimeout(() => {
      var I;
      i((I = e.voice) == null ? void 0 : I.defaultToggledOn);
    }, 1);
  }, []), J(() => {
    var E;
    (E = e.notification) != null && E.disabled || C();
  }, [(b = e.notification) == null ? void 0 : b.disabled]), J(() => {
    !f.current && (d != null && d.current) && S();
  }, [t]), J(() => {
    var E, m;
    if ((E = e.chatHistory) != null && E.disabled)
      St();
    else if (FA(e), GA().length > 0) {
      const M = gA(/* @__PURE__ */ l(wo, {}), "SYSTEM");
      o([M]), (m = e.chatHistory) != null && m.autoLoad && P();
    }
  }, [(T = e.chatHistory) == null ? void 0 : T.storageKey, (O = e.chatHistory) == null ? void 0 : O.maxEntries, (Q = e.chatHistory) == null ? void 0 : Q.disabled]), J(() => {
    var E;
    A || (E = e.general) != null && E.embedded || !navigator.virtualKeyboard || (navigator.virtualKeyboard.overlaysContent = !0, navigator.virtualKeyboard.addEventListener("geometrychange", (m) => {
      if (!m.target)
        return;
      const { x: p, y: M, width: k, height: I } = m.target.boundingRect;
      p == 0 && M == 0 && k == 0 && I == 0 ? (setTimeout(() => {
        var L;
        B((L = window.visualViewport) == null ? void 0 : L.height);
      }, 101), setTimeout(() => {
        var L, Y;
        g != ((L = window.visualViewport) == null ? void 0 : L.height) && B((Y = window.visualViewport) == null ? void 0 : Y.height);
      }, 1001)) : setTimeout(() => {
        var L;
        B(((L = window.visualViewport) == null ? void 0 : L.height) - I);
      }, 101);
    }));
  }, [A]), J(() => {
    var k, I, L, Y;
    if (A)
      return;
    n && (B((k = window.visualViewport) == null ? void 0 : k.height), v((I = window.visualViewport) == null ? void 0 : I.width));
    const E = () => window.scrollTo({ top: 0, left: 0, behavior: "auto" }), m = () => D.current = window.scrollY, p = () => {
      var K, G;
      B((K = window.visualViewport) == null ? void 0 : K.height), v((G = window.visualViewport) == null ? void 0 : G.width);
    }, M = () => {
      var K;
      window.removeEventListener("scroll", E), window.removeEventListener("scroll", m), (K = window.visualViewport) == null || K.removeEventListener("resize", p);
    };
    return n ? (M(), document.body.style.position = "fixed", window.addEventListener("scroll", E), (L = window.visualViewport) == null || L.addEventListener("resize", p)) : (document.body.style.position = "static", M(), window.scrollTo({ top: D.current, left: 0, behavior: "auto" }), window.addEventListener("scroll", m), (Y = window.visualViewport) == null || Y.removeEventListener("resize", p)), M;
  }, [n, A]);
}, JA = {
  DEFAULT_URL: "https://cdn.jsdelivr.net/gh/react-chatbotify/community-themes/themes",
  DEFAULT_EXPIRATION: "2592000",
  CACHE_KEY_PREFIX: "RCB_THEME_CACHE_DATA"
}, Bo = JA.DEFAULT_URL, vo = JA.DEFAULT_EXPIRATION, Qe = JA.CACHE_KEY_PREFIX, ho = (A, e, o) => {
  const t = localStorage.getItem(`${Qe}_${A}_${e}`);
  if (!t)
    return null;
  try {
    const n = JSON.parse(t), s = (/* @__PURE__ */ new Date()).getTime(), a = Math.floor(s / 1e3);
    return n.cacheDate + o >= a ? n : null;
  } catch (n) {
    return console.error(`Unable to fetch cache for ${A}`, n), null;
  }
}, Po = (A, e, o, t, n) => {
  const s = (/* @__PURE__ */ new Date()).getTime(), a = Math.floor(s / 1e3), r = {
    settings: o,
    inlineStyles: t,
    cssStylesText: n,
    cacheDate: a
  };
  localStorage.setItem(`${Qe}_${A}_${e}`, JSON.stringify(r));
}, Do = async (A, e) => {
  const o = `${e}/${A}/meta.json`;
  try {
    const t = await fetch(o);
    return t.ok ? (await t.json()).version : (console.error(`Failed to fetch meta.json from ${o}`), null);
  } catch (t) {
    return console.error(`Failed to fetch meta.json from ${o}`, t), null;
  }
}, ne = async (A, e) => {
  const { id: o, version: t, baseUrl: n = Bo, cacheDuration: s = vo } = e, a = t || await Do(o, n);
  if (!a)
    return console.error(`Unable to find version for theme: ${o}`), { settings: {}, inlineStyles: {}, cssStylesText: "" };
  const r = ho(o, a, s);
  if (r) {
    const C = se(A, r.cssStylesText);
    return { settings: r.settings, inlineStyles: r.inlineStyles, cssStylesText: C };
  }
  const c = `${n}/${o}/${a}/styles.css`, i = `${n}/${o}/${a}/settings.json`, u = `${n}/${o}/${a}/styles.json`;
  let f = "";
  const w = await fetch(c);
  w.ok ? f = await w.text() : console.info(`Could not fetch styles.css from ${c}`);
  const d = await fetch(i);
  let g = {};
  d.ok ? g = await d.json() : console.info(`Could not fetch settings.json from ${i}`);
  const B = await fetch(u);
  let v = {};
  B.ok ? v = await B.json() : console.info(`Could not fetch styles.json from ${u}`), Po(o, a, g, v, f);
  const S = se(A, f);
  return { settings: g, inlineStyles: v, cssStylesText: S };
}, se = (A, e) => e.split(new RegExp("(?<=})")).map((t) => {
  const n = t.trim();
  return n.startsWith("@import") || n.startsWith("@keyframes") || n.startsWith("@media") ? n : n ? `#${A} ${n}` : "";
}).join(`
`), Eo = () => HA(re), yo = () => HA(ce), Co = async (A, e, o, t) => {
  var r, c;
  let n = Eo(), s = yo(), a = "";
  if (t != null)
    if (Array.isArray(t))
      for (const i of t) {
        const u = await ne(A, i);
        n = fA(u.settings, n), s = fA(u.inlineStyles, s), a += u.cssStylesText;
      }
    else {
      const i = await ne(A, t);
      n = fA(i.settings, n), s = fA(i.inlineStyles, s), a += i.cssStylesText;
    }
  return e != null && (n = fA(e, n)), o != null && (s = fA(o, s)), ((r = n.chatInput) == null ? void 0 : r.botDelay) != null && ((c = n.chatInput) == null ? void 0 : c.botDelay) < 500 && (n.chatInput.botDelay = 500), { settings: n, inlineStyles: s, cssStylesText: a };
}, fA = (A, e) => {
  const o = [{ source: A, target: e }];
  for (; o.length; ) {
    const t = o.pop();
    if (t == null)
      continue;
    const { source: n, target: s } = t;
    for (const a of Object.keys(n)) {
      const r = a;
      if (UA(n[r]))
        s[r] = n[r];
      else if (typeof n[r] == "object" && n[r] !== null && !Array.isArray(n[r]))
        (typeof s[r] != "object" || s[r] === null) && (s[r] = {}), o.push({ source: n[r], target: s[r] });
      else
        try {
          s[r] = n[r];
        } catch {
        }
    }
  }
  return e;
}, HA = (A) => {
  if (A === null || typeof A != "object")
    return A;
  const e = Array.isArray(A) ? [] : {}, o = [{ source: A, target: e }], t = /* @__PURE__ */ new WeakMap();
  for (t.set(A, e); o.length; ) {
    const n = o.pop();
    if (n == null)
      continue;
    const { source: s, target: a } = n;
    for (const r in s)
      if (Object.prototype.hasOwnProperty.call(s, r)) {
        const c = s[r];
        if (c && typeof c == "object")
          if (t.has(c))
            a[r] = t.get(c);
          else {
            const i = Array.isArray(c) ? [] : {};
            t.set(c, i), a[r] = i, o.push({ source: c, target: i });
          }
        else
          a[r] = c;
      }
  }
  return e;
}, be = () => {
  const { settings: A, setSyncedSettings: e, syncedSettingsRef: o } = N(), t = H((s) => {
    !s || Object.keys(s).length === 0 || e(HA(fA(s, A)));
  }, [A]), n = H((s) => {
    const a = typeof s == "function" ? s(o.current) : s;
    e(a);
  }, [o]);
  return {
    settings: A,
    replaceSettings: n,
    updateSettings: t
  };
}, pe = () => {
  const { styles: A, setSyncedStyles: e, syncedStylesRef: o } = X(), t = H((s) => {
    !s || Object.keys(s).length === 0 || e(HA(fA(s, A)));
  }, [A]), n = H((s) => {
    const a = typeof s == "function" ? s(o.current) : s;
    e(a);
  }, [o]);
  return {
    styles: A,
    replaceStyles: n,
    updateStyles: t
  };
}, mo = (A) => {
  const { updateSettings: e } = be(), { updateStyles: o } = pe(), t = A == null ? void 0 : A.map((n) => n());
  J(() => {
    let n = {}, s = {};
    t == null || t.forEach((a) => {
      a != null && a.settings && Object.keys(a == null ? void 0 : a.settings).length !== 0 && (n = fA(a.settings, n)), a != null && a.styles && Object.keys(a == null ? void 0 : a.styles).length !== 0 && (s = fA(a.styles, s));
    }), e(n), o(s);
  }, []);
}, Qo = ({
  plugins: A,
  slots: e
}) => {
  var C, h;
  const o = kA(), { settings: t } = N(), { styles: n } = X(), { hasFlowStarted: s, setHasFlowStarted: a } = AA(), { inputRef: r } = _(), {
    viewportHeight: c,
    viewportWidth: i,
    isChatWindowOpen: u
  } = aA(), { goToPath: f } = bA(), { headerButtons: w, chatInputButtons: d, footerButtons: g } = fo();
  go(), mo(A), J(() => {
    var P;
    (s || ((P = t.general) == null ? void 0 : P.flowStartTrigger) === "ON_LOAD") && f("start");
  }, [s, (C = t.general) == null ? void 0 : C.flowStartTrigger]);
  const B = dA(() => {
    var D;
    const P = "rcb-chatbot-global ";
    return (D = t.general) != null && D.embedded ? P + "rcb-window-embedded" : u ? P + "rcb-window-open" : P + "rcb-window-close";
  }, [t, u]), v = () => {
    var P, D;
    return !o && !((P = t.general) != null && P.embedded) ? {
      ...n.chatWindowStyle,
      borderRadius: "0px",
      left: "0px",
      right: "auto",
      top: "0px",
      bottom: "auto",
      width: `${i}px`,
      height: `${c}px`,
      zIndex: 1e4
    } : (D = t.general) != null && D.embedded ? { ...n.chatWindowStyle } : {
      ...n.chatWindowStyle,
      zIndex: 1e4
    };
  };
  return /* @__PURE__ */ l(oA, { children: (() => {
    var P, D;
    return o && ((P = t.device) == null ? void 0 : P.desktopEnabled) || !o && ((D = t.device) == null ? void 0 : D.mobileEnabled);
  })() && /* @__PURE__ */ W(
    "div",
    {
      onMouseDown: (P) => {
        var D, y;
        !s && ((D = t.general) == null ? void 0 : D.flowStartTrigger) === "ON_CHATBOT_INTERACT" && a(!0), o ? (y = r.current) == null || y.blur() : P == null || P.preventDefault();
      },
      className: B,
      children: [
        /* @__PURE__ */ l(Wt, {}),
        /* @__PURE__ */ l(Xt, {}),
        u && !o && !((h = t.general) != null && h.embedded) && /* @__PURE__ */ W(oA, { children: [
          /* @__PURE__ */ l("style", { children: `
									html {
										overflow: hidden !important;
										touch-action: none !important;
										scroll-behavior: auto !important;
									}
								` }),
          /* @__PURE__ */ l(
            "div",
            {
              style: {
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
                zIndex: 9999
              }
            }
          )
        ] }),
        /* @__PURE__ */ l("div", { style: v(), className: "rcb-chat-window", children: (() => {
          var T, O, Q;
          const P = (e == null ? void 0 : e.chatBotHeader) || tt, D = (e == null ? void 0 : e.chatBotBody) || ft, y = (e == null ? void 0 : e.chatBotInput) || Gt, b = (e == null ? void 0 : e.chatBotFooter) || Yt;
          return /* @__PURE__ */ W(oA, { children: [
            ((T = t.general) == null ? void 0 : T.showHeader) && /* @__PURE__ */ l(P, { buttons: w }),
            /* @__PURE__ */ l(D, {}),
            /* @__PURE__ */ l(qt, {}),
            ((O = t.general) == null ? void 0 : O.showInputRow) && /* @__PURE__ */ l(y, { buttons: d }),
            ((Q = t.general) == null ? void 0 : Q.showFooter) && /* @__PURE__ */ l(b, { buttons: g })
          ] });
        })() })
      ]
    }
  ) });
}, Se = vA(void 0), Ie = () => hA(Se), bo = ({
  children: A
}) => {
  var w;
  const e = $(""), o = $({}), [t, n, s] = rA({}), [a, r, c] = rA({}), [i, u] = z(!1);
  J(() => {
    u(!0);
  }, []);
  const f = async (d, g, B, v, S, C) => {
    e.current = d, o.current = g;
    const h = await Co(d, B, v, S);
    C.current && (C.current.textContent = h.cssStylesText), n(h.settings), r(h.inlineStyles);
  };
  return i ? /* @__PURE__ */ l("div", { style: { fontFamily: (w = t.general) == null ? void 0 : w.fontFamily }, children: /* @__PURE__ */ l(Se.Provider, { value: { loadConfig: f }, children: /* @__PURE__ */ l(
    At,
    {
      settings: t,
      setSyncedSettings: n,
      syncedSettingsRef: s,
      children: /* @__PURE__ */ l(
        et,
        {
          styles: a,
          setSyncedStyles: r,
          syncedStylesRef: c,
          children: /* @__PURE__ */ l(zt, { children: /* @__PURE__ */ l(ot, { botIdRef: e, flowRef: o, children: /* @__PURE__ */ l(rt, { children: /* @__PURE__ */ l(nt, { settings: t, children: /* @__PURE__ */ l(ct, { children: A }) }) }) }) })
        }
      )
    }
  ) }) }) : null;
}, po = ({
  id: A,
  flow: e,
  settings: o,
  styles: t,
  themes: n,
  plugins: s,
  setConfigLoaded: a,
  styleRootRef: r
}) => {
  const c = dA(() => A, []), i = Ie(), { flowRef: u } = _();
  u && u.current !== e && (u.current = e);
  const f = async () => {
    var w, d;
    (w = o.event) != null && w.rcbPreLoadChatBot && (await RA(
      x.PRE_LOAD_CHATBOT,
      { botId: c, currPath: null, prevPath: null },
      {
        flow: e,
        settings: o,
        styles: t,
        themes: n,
        plugins: s
      }
    )).defaultPrevented || (i != null && i.loadConfig && (await i.loadConfig(c, e, o, t, n, r), a(!0)), (d = o.event) != null && d.rcbPostLoadChatBot && RA(
      x.POST_LOAD_CHATBOT,
      { botId: c, currPath: null, prevPath: null },
      {
        flow: e,
        settings: o,
        styles: t,
        themes: n,
        plugins: s
      }
    ));
  };
  return J(() => {
    f();
  }, [n]), null;
}, NA = ["Quickstart", "API Docs", "Examples", "Github", "Discord"], So = {
  start: {
    message: "Hello, I am Tan Jin 👋! Welcome to React ChatBotify, I'm excited that you are using our chatbot 😊!",
    transition: { duration: 1e3 },
    chatDisabled: !0,
    path: "show_options"
  },
  show_options: {
    message: "It looks like you have not set up a conversation flow yet. No worries! Here are a few helpful things you can check out to get started:",
    options: NA,
    path: "process_options"
  },
  prompt_again: {
    message: "Do you need any other help?",
    options: NA,
    path: "process_options"
  },
  unknown_input: {
    message: "Sorry, I do not understand your message 😢! If you require further assistance, you may click on the Github option and open an issue there or visit our discord.",
    options: NA,
    path: "process_options"
  },
  process_options: {
    transition: { duration: 0 },
    path: (A) => {
      let e = "";
      switch (A.userInput) {
        case "Quickstart":
          e = "https://react-chatbotify.com/docs/introduction/quickstart/";
          break;
        case "API Docs":
          e = "https://react-chatbotify.com/docs/api/bot_options";
          break;
        case "Examples":
          e = "https://react-chatbotify.com/docs/examples/basic_form";
          break;
        case "Github":
          e = "https://github.com/react-chatbotify/react-chatbotify/";
          break;
        case "Discord":
          e = "https://discord.gg/6R4DK4G5Zh";
          break;
        default:
          return "unknown_input";
      }
      return A.injectMessage("Sit tight! I'll send you right there!"), setTimeout(() => {
        window.open(e);
      }, 1e3), "repeat";
    }
  },
  repeat: {
    transition: { duration: 3e3 },
    path: "prompt_again"
  }
}, Lo = ({
  id: A,
  flow: e,
  settings: o,
  styles: t,
  themes: n,
  plugins: s,
  slots: a
}) => {
  const r = dA(() => A || "rcb-" + IA(), []), c = !e || Object.keys(e).length === 0 ? So : e, i = o || {}, u = t || {}, f = s || [], [w, d] = z(!1), g = Ie(), B = $(null), [v, S] = z(n || []);
  J(() => {
    n && S(n);
  }, [n]);
  const C = () => /* @__PURE__ */ W(oA, { children: [
    /* @__PURE__ */ l(
      po,
      {
        styleRootRef: B,
        id: r,
        flow: c,
        settings: i,
        styles: u,
        themes: v,
        plugins: f,
        setConfigLoaded: d
      }
    ),
    w && /* @__PURE__ */ l(Qo, { plugins: s, slots: a })
  ] });
  return g == null ? /* @__PURE__ */ W(bo, { children: [
    /* @__PURE__ */ l("style", { ref: B }),
    /* @__PURE__ */ l("div", { id: r, children: C() })
  ] }) : /* @__PURE__ */ W(oA, { children: [
    /* @__PURE__ */ l("style", { ref: B }),
    /* @__PURE__ */ l("div", { id: r, children: C() })
  ] });
}, No = () => {
  const { audioToggledOn: A, speakAudio: e, toggleAudio: o } = XA();
  return {
    audioToggledOn: A,
    speakAudio: e,
    toggleAudio: o
  };
}, Io = () => {
  const { botIdRef: A } = _();
  return {
    getBotId: H(() => A.current, [A])
  };
}, To = () => {
  const { getBotId: A } = Io();
  return {
    getBotId: A
  };
}, Ro = () => {
  const {
    isChatWindowOpen: A,
    toggleChatWindow: e,
    toggleIsBotTyping: o,
    scrollToBottom: t,
    getIsChatBotVisible: n
  } = aA();
  return {
    isChatWindowOpen: A,
    toggleChatWindow: e,
    toggleIsBotTyping: o,
    scrollToBottom: t,
    getIsChatBotVisible: n
  };
}, Fo = () => {
  const { hasInteractedPage: A } = me();
  return {
    hasInteractedPage: A
  };
}, Mo = () => {
  const { replaceMessages: A } = PA(), { replacePaths: e, goToPath: o } = bA(), { replaceToasts: t } = EA(), { hasFlowStarted: n } = AA(), { flowRef: s, timeoutIdRef: a } = _(), { settings: r } = N(), c = H(async () => {
    FA(r), a.current && clearTimeout(a.current), A([]), t([]), e([]), await o("start");
  }, [a, r, A, t, e, FA, o]), i = H(() => (s == null ? void 0 : s.current) ?? {}, [s]);
  return {
    hasFlowStarted: n,
    restartFlow: c,
    getFlow: i
  };
}, Uo = () => {
  const { hasFlowStarted: A, restartFlow: e, getFlow: o } = Mo();
  return {
    hasFlowStarted: A,
    restartFlow: e,
    getFlow: o
  };
}, jo = () => {
  const {
    endStreamMessage: A,
    injectMessage: e,
    removeMessage: o,
    simulateStreamMessage: t,
    streamMessage: n,
    messages: s,
    replaceMessages: a,
    getMessages: r
  } = PA();
  return {
    endStreamMessage: A,
    injectMessage: e,
    removeMessage: o,
    simulateStreamMessage: t,
    streamMessage: n,
    messages: s,
    replaceMessages: a,
    getMessages: r
  };
}, zo = (A, e) => {
  const { getBotId: o } = To();
  J(() => {
    const t = (n) => {
      n.detail.botId === o() && e(n);
    };
    return window.addEventListener(A, t), () => {
      window.removeEventListener(A, t);
    };
  }, [o, A, e]);
}, Go = () => {
  const {
    getCurrPath: A,
    getPrevPath: e,
    goToPath: o,
    paths: t,
    replacePaths: n
  } = bA();
  return {
    getCurrPath: A,
    getPrevPath: e,
    goToPath: o,
    paths: t,
    replacePaths: n
  };
}, Yo = () => {
  const { settings: A, replaceSettings: e, updateSettings: o } = be();
  return {
    settings: A,
    replaceSettings: e,
    updateSettings: o
  };
}, Xo = () => {
  const { styles: A, replaceStyles: e, updateStyles: o } = pe();
  return {
    styles: A,
    replaceStyles: e,
    updateStyles: o
  };
}, Wo = () => {
  const {
    textAreaDisabled: A,
    toggleTextAreaDisabled: e,
    textAreaSensitiveMode: o,
    toggleTextAreaSensitiveMode: t,
    getTextAreaValue: n,
    setTextAreaValue: s,
    focusTextArea: a,
    blurTextArea: r
  } = DA();
  return {
    textAreaDisabled: A,
    toggleTextAreaDisabled: e,
    textAreaSensitiveMode: o,
    toggleTextAreaSensitiveMode: t,
    getTextAreaValue: n,
    setTextAreaValue: s,
    focusTextArea: a,
    blurTextArea: r
  };
}, Ko = () => {
  const { showToast: A, dismissToast: e, toasts: o, replaceToasts: t } = EA();
  return {
    showToast: A,
    dismissToast: e,
    toasts: o,
    replaceToasts: t
  };
}, qo = () => {
  const { voiceToggledOn: A, toggleVoice: e } = MA();
  return {
    voiceToggledOn: A,
    toggleVoice: e
  };
}, Jo = () => {
  const { showChatHistory: A, hasChatHistoryLoaded: e } = qA();
  return {
    showChatHistory: A,
    getHistoryMessages: GA,
    setHistoryMessages: pt,
    hasChatHistoryLoaded: e
  };
};
export {
  Z as Button,
  bo as ChatBotProvider,
  x as RcbEvent,
  Lo as default,
  Eo as getDefaultSettings,
  yo as getDefaultStyles,
  No as useAudio,
  To as useBotId,
  Jo as useChatHistory,
  Ro as useChatWindow,
  Fo as useFirstInteraction,
  Uo as useFlow,
  jo as useMessages,
  $t as useNotifications,
  zo as useOnRcbEvent,
  Go as usePaths,
  Yo as useSettings,
  Xo as useStyles,
  Wo as useTextArea,
  Ko as useToasts,
  qo as useVoice
};
